import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Stack,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Snackbar
} from '@mui/material';

import { SelectChangeEvent } from '@mui/material/Select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';

const ModernButton = styled(Button)({
  borderRadius: '8px',
  padding: '8px 16px',
  fontSize: '0.8125rem',
  fontWeight: 500,
  textTransform: 'none',
  letterSpacing: '0.02em',
  transition: 'all 0.2s ease',
  border: '1px solid',
  '&:hover': {
    transform: 'translateY(-1px)',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
  }
});

const PrimaryButton = styled(ModernButton)({
  backgroundColor: '#1976d2',
  color: '#fff',
  borderColor: 'transparent',
  '&:hover': {
    backgroundColor: '#1565c0',
    borderColor: 'transparent'
  }
});

const selectStyles = {
  color: '#ECEFF1',
  '.MuiOutlinedInput-notchedOutline': {   borderColor: '#B0BEC5'
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {   borderColor: '#90A4AE'
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {   borderColor: '#CFD8DC'
  },
  '&.Mui-disabled': { color: '#888',  backgroundColor: '#1e1e1e'
  },
  '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {  borderColor: '#555'  },
  svg: {
    color: '#90A4AE'  }
};

const labelStyles = {
  color: '#90A4AE',
  '&.Mui-focused': {
    color: '#B0BEC5'
  }
};

const preheatingValveOptions = ['On/Off Valve Actuator', 'On/Off Valve Actuator with Feedback', 'Floating Valve Actuator', 'Floating Valve Actuator with Feedback','Proportional Valve Actuator', 'Proportional Valve Actuator with Feedback'];

const heatingValveOptions = [ 'On/Off Valve Actuator', 'On/Off Valve Actuator with Feedback', 'Floating Valve Actuator', 'Floating Valve Actuator with Feedback','Proportional Valve Actuator','Proportional Valve Actuator with Feedback'];

const coolingValveOptions = [ 'On/Off Valve Actuator', 'On/Off Valve Actuator with Feedback', 'Floating Valve Actuator', 'Floating Valve Actuator with Feedback','Proportional Valve Actuator', 'Proportional Valve Actuator with Feedback'];

const coolingDXOptions = [ '1-Staged DX Unit', '2-Staged DX Unit', '3-Staged DX Unit', 'Proportional DX Unit'];

export default function AhuPage() {
  const navigate = useNavigate();
  const loggedInUser = localStorage.getItem('loggedInUser');

  const [projectCode, setProjectCode] = useState('');
  const [description, setDescription] = useState('');
  const [location, setLocation] = useState('');
  const [ahuControl, setAhuControl] = useState('');
  const [ahucontrolpackagedprotocolIntegration, setAhuControlPackagedProtocolIntegration] = useState('');
  const [ahuControlPackagedPoints, setAhuControlPackagedPoints] = useState('');
  const [ahucontrolpackagedhardpoints, setAhuControlPackagedHardPoints] = useState('');
  const [vantControl, setVantControl] = useState('');
  const [vantPieces, setVantPieces] = useState('');
  const [fanPower, setFanPower] = useState('');
  const [fanVoltage, setFanVoltage] = useState('');
  const [aspControl, setAspControl] = useState('');
  const [aspPieces, setAspPieces] = useState('');
  const [aspPower, setAspPower] = useState('');
  const [aspVoltage, setAspVoltage] = useState('');
  const [maintenanceSafety, setMaintenanceSafety] = useState('');
  const [emergencySafety, setEmergencySafety] = useState('');
  const [doorSafety, setDoorSafety] = useState('');
  const [fireSafety, setFireSafety] = useState('');
  const [frostSafety, setFrostSafety] = useState('');
  const [preheatingFunction, setPreheatingFunction] = useState('');
  const [preheatingPower, setPreheatingPower] = useState('');
  const [preheatingVoltage, setPreheatingVoltage] = useState('');
  const [preheatingTemperature, setPreheatingTemperature] = useState('');
  const [heatingFunction, setHeatingFunction] = useState('');
  const [heatingPieces, setHeatingPieces] = useState('');
  const [heatingPower, setHeatingPower] = useState('');
  const [heatingVoltage, setHeatingVoltage] = useState('');
  const [heatingTemperature, setHeatingTemperature] = useState('');
  const [coolingFunction, setCoolingFunction] = useState('');
  const [coolingPieces, setCoolingPieces] = useState('');
  const [coolingPower, setCoolingPower] = useState('');
  const [coolingVoltage, setCoolingVoltage] = useState('');
  const [coolingTemperature, setCoolingTemperature] = useState('');
  const [supplyAirSensor, setSupplyAirSensor] = useState('');
  const [freshAirSensor, setFreshAirSensor] = useState('');
  const [returnAirSensor, setReturnAirSensor] = useState('');
  const [exhaustAirSensor, setExhaustAirSensor] = useState('');
  const [mixedAirSensor, setMixedAirSensor] = useState('');
  const [dehumidificationAirSensor, setDehumidificationAirSensor] = useState('');
  const [heatExchangerAirSensor, setHeatExchangerAirSensor] = useState('');
  const [freshDamperActuator, setFreshDamperActuator] = useState('');
  const [supplyDamperActuator, setSupplyDamperActuator] = useState('');
  const [returnDamperActuator, setReturnDamperActuator] = useState('');
  const [exhaustDamperActuator, setExhaustDamperActuator] = useState('');
  const [mixedDamperActuator, setMixedDamperActuator] = useState('');
  const [reCirculationDamperActuator, setReCirculationDamperActuator] = useState('');
  const [recuperatorDamperActuator, setRecuperatorDamperActuator] = useState('');
  const [supplyFilter, setSupplyFilter] = useState('');
  const [freshFilter, setFreshFilter] = useState('');
  const [returnFilter, setReturnFilter] = useState('');
  const [exhaustFilter, setExhaustFilter] = useState('');
  const [recuperatorFilter, setRecuperatorFilter] = useState('');
  const [supplyFlow, setSupplyFlow] = useState('');
  const [returnFlow, setReturnFlow] = useState('');
  const [runAroundPumpControl, setRunAroundPumpControl] = useState('');
  const [runAroundPumpPieces, setRunAroundPumpPieces] = useState('');
  const [pumpPower, setPumpPower] = useState('');
  const [pumpVoltage, setPumpVoltage] = useState('');
  const [runAroundTemperature, setRunAroundTemperature] = useState('');
  const [heatRecoveryControl, setHeatRecoveryControl] = useState('');
  const [heatRecoveryPower, setHeatRecoveryPower] = useState('');
  const [heatRecoveryVoltage, setHeatRecoveryVoltage] = useState('');
  const [humidificationFunction, setHumidificationFunction] = useState('');
  const [humidificationPower, setHumidificationPower] = useState('');
  const [humidificationVoltage, setHumidificationVoltage] = useState('');
  const [dehumidificationFunction, setDehumidificationFunction] = useState('');
  const [dehumidificationPower, setDehumidificationPower] = useState('');
  const [dehumidificationVoltage, setDehumidificationVoltage] = useState('');
  const [fanIntegration, setFanIntegration] = useState('');
  const [fanprotocolIntegration, setFanProtocolIntegration] = useState('');
  const [fanIntegrationPoints, setFanIntegrationPoints] = useState('');

  const [runaroundpumpIntegration, setRunAroundPumpIntegration] = useState('');
  const [runaroundpumpprotocolIntegration, setRunAroundPumpProtocolIntegration] = useState('');
  const [runaroundpumpIntegrationPoints, setRunAroundPumpIntegrationPoints] = useState('');

  const [heatexchangerIntegration, setHeatExchangerIntegration] = useState('');
  const [heatexchangerprotocolIntegration, setHeatExchangerProtocolIntegration] = useState('');
  const [heatexchangerIntegrationPoints, setHeatExchangerIntegrationPoints] = useState('');

  const [humidificationIntegration, setHumidificationIntegration] = useState('');
  const [humidificationprotocolIntegration, setHumidificationProtocolIntegration] = useState('');
  const [humidificationIntegrationPoints, setHumidificationIntegrationPoints] = useState('');

  const [dehumidificationIntegration, setDehumidificationIntegration] = useState('');
  const [dehumidificationprotocolIntegration, setDehumidificationProtocolIntegration] = useState('');
  const [dehumidificationIntegrationPoints, setDehumidificationIntegrationPoints] = useState('');

  const [showTable, setShowTable] = useState(false);
  const [tableRows, setTableRows] = useState<any[]>([]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState('');


  const [isPackaged, setIsPackaged] = useState(false);

  const isPreheatingTemperatureDisabled = () => {
    return (
      preheatingFunction === 'none' || preheatingFunction.includes('Electrical Heater')
    );
  };



React.useEffect(() => {
  if (ahuControl === 'Packaged') {
    setVantControl('');
    setVantPieces('');
    setFanPower('');
    setFanVoltage('');
    setAspControl('');
    setAspPieces('');
    setAspPower('');
    setAspVoltage('');
    setMaintenanceSafety('');
    setEmergencySafety('');
    setDoorSafety('');
    setFireSafety('');
    setFrostSafety('');
    setPreheatingFunction('');
    setPreheatingPower('');
    setPreheatingVoltage('');
    setPreheatingTemperature('');
    setHeatingFunction('');
    setHeatingPower('');
    setHeatingVoltage('');
    setHeatingTemperature('');
    setCoolingFunction('');
    setCoolingPower('');
    setCoolingVoltage('');
    setCoolingTemperature('');
    setSupplyAirSensor('');
    setFreshAirSensor('');
    setReturnAirSensor('');
    setExhaustAirSensor('');
    setMixedAirSensor('');
    setDehumidificationAirSensor('');
    setHeatExchangerAirSensor('');
    setFreshDamperActuator('');
    setSupplyDamperActuator('');
    setReturnDamperActuator('');
    setExhaustDamperActuator('');
    setMixedDamperActuator('');
    setReCirculationDamperActuator('');
    setRecuperatorDamperActuator('');
    setSupplyFilter('');
    setFreshFilter('');
    setReturnFilter('');
    setExhaustFilter('');
    setRecuperatorFilter('');
    setSupplyFlow('');
    setReturnFlow('');
    setRunAroundPumpControl('');
    setRunAroundPumpPieces('');
    setPumpPower('');
    setPumpVoltage('');
    setRunAroundTemperature('');
    setHeatRecoveryControl('');
    setHeatRecoveryPower('');
    setHeatRecoveryVoltage('');
    setHumidificationFunction('');
    setHumidificationPower('');
    setHumidificationVoltage('');
    setDehumidificationFunction('');
    setDehumidificationPower('');
    setDehumidificationVoltage('');
    setFanIntegration('');
    setFanProtocolIntegration('');
    setFanIntegrationPoints('');
    setRunAroundPumpIntegration('');
    setRunAroundPumpProtocolIntegration('');
    setRunAroundPumpIntegrationPoints('');
    setHeatExchangerIntegration('');
    setHeatExchangerProtocolIntegration('');
    setHeatExchangerIntegrationPoints('');
    setHumidificationIntegration('');
    setHumidificationProtocolIntegration('');
    setHumidificationIntegrationPoints('');
    setDehumidificationIntegration('');
    setDehumidificationProtocolIntegration('');
    setDehumidificationIntegrationPoints('');
  }
}, [ahuControl]);




  React.useEffect(() => {
  if (
    preheatingFunction === 'none' || preheatingFunction.includes('Electrical Heater')
  ) {
    setPreheatingTemperature('');
  }
}, [preheatingFunction]);

  const isHeatingTemperatureDisabled = () => {
    return (
      heatingFunction === 'none' || heatingFunction.includes('Electrical Heater')
    );
  };

React.useEffect(() => {
  if (
    heatingFunction === 'none' || heatingFunction.includes('Electrical Heater')
  ) {
    setHeatingTemperature('');
  }
}, [heatingFunction]);

  const handleBack = () => {
    navigate('/projects');
  };

React.useEffect(() => {
  if (
    coolingFunction === 'none' || coolingDXOptions.includes(coolingFunction)
  ) {
    setCoolingTemperature('');
  }
}, [coolingFunction]);

  const handleLogout = () => {
    navigate('/');
  };

React.useEffect(() => {
  if (runAroundPumpControl === 'none') {
    setRunAroundPumpPieces('');
    setPumpPower('');
    setPumpVoltage('');
    setRunAroundTemperature('');
  }
}, [runAroundPumpControl]);

  React.useEffect(() => {
  if (heatRecoveryControl === 'none') {
    setHeatRecoveryPower('');
    setHeatRecoveryVoltage('');
  }
}, [heatRecoveryControl]);


React.useEffect(() => {
  if (fanIntegration === 'none') {
    setFanProtocolIntegration('');
    setFanIntegrationPoints('');
  }
}, [fanIntegration]);


React.useEffect(() => {
  if (runaroundpumpIntegration === 'none') {
    setRunAroundPumpProtocolIntegration('');
    setRunAroundPumpIntegrationPoints('');
  }
}, [runaroundpumpIntegration]);



React.useEffect(() => {
  if (heatexchangerIntegration === 'none') {
    setHeatExchangerProtocolIntegration('');
    setHeatExchangerIntegrationPoints('');
  }
}, [heatexchangerIntegration]);

React.useEffect(() => {
  if (humidificationIntegration === 'none') {
    setHumidificationProtocolIntegration('');
    setHumidificationIntegrationPoints('');
  }
}, [humidificationIntegration]);

React.useEffect(() => {
  if (dehumidificationIntegration === 'none') {
    setDehumidificationProtocolIntegration('');
    setDehumidificationIntegrationPoints('');
  }
}, [dehumidificationIntegration]);


React.useEffect(() => {
  if (ahuControl === 'MCC') {
    setAhuControlPackagedProtocolIntegration('');
    setAhuControlPackagedHardPoints('');
    setAhuControlPackagedPoints('');
  }
}, [ahuControl]);


React.useEffect(() => {
  if (heatRecoveryControl === 'none' || heatRecoveryControl === 'Plate Recuperator' || isPackaged) {
    setHeatRecoveryPower('');
    setHeatRecoveryVoltage('');
  }
}, [heatRecoveryControl, isPackaged]);

  const renderDropdown = (
    label: string,
    value: string,
    onChange: (e: SelectChangeEvent) => void,
    options: string[],
    disabled: boolean = false // yeni eklendi
  ) => (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel sx={labelStyles}>{label}</InputLabel>
      <Select value={value} label={label} onChange={onChange} sx={selectStyles}>
        {options.map((option, index) => (
          <MenuItem key={index} value={option}>{option}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );

const handleAspControlChange = (e: SelectChangeEvent) => {

  
  const value = e.target.value;
  setAspControl(value);

  if (value === 'none') {
    setAspPieces('');
    setAspPower('');
    setAspVoltage('');
  }
};

const handlePreheatingFunctionChange = (e: SelectChangeEvent) => {
  const value = e.target.value;
  setPreheatingFunction(value);

  if (preheatingValveOptions.includes(value)) {
    setPreheatingPower('');
    setPreheatingVoltage('');
  }
};

const handleHeatingFunctionChange = (e: SelectChangeEvent) => {
  const value = e.target.value;
  setHeatingFunction(value);

  if (heatingValveOptions.includes(value)) {
    setHeatingPower('');
    setHeatingVoltage('');
  }
};

const handleCoolingFunctionChange = (e: SelectChangeEvent) => {
  const value = e.target.value;
  setCoolingFunction(value);

  const isCoolingValve = coolingValveOptions.includes(value);
  const isCoolingDx = coolingDXOptions.includes(value); // DX Unit grubu

  // Power ve Voltage temizle
  if (value === 'none' || isCoolingValve) {
    setCoolingPower('');
    setCoolingVoltage('');
  }

  // Coil Temperature temizle (hem none hem DX seçildiyse)
  if (value === 'none' || isCoolingDx) {
    setCoolingTemperature('');
  }
};


const handleAhuControlChange = (event: SelectChangeEvent<string>) => {
  const selectedValue = event.target.value;
  setAhuControl(selectedValue);

  const packagedSelected = selectedValue === "Packaged";
  setIsPackaged(packagedSelected);

  if (packagedSelected) {
    setVantControl('');
    setVantPieces('');
    setFanPower('');
    setFanVoltage('');
    setAspControl('');
    setAspPieces('');
    setAspPower('');
    setAspVoltage('');
    setMaintenanceSafety('');
    setEmergencySafety('');
    setDoorSafety('');
    setFireSafety('');
    setFrostSafety('');
    setPreheatingFunction('');
    setPreheatingPower('');
    setPreheatingVoltage('');
    setPreheatingTemperature('');
    setHeatingFunction('');
    setHeatingPower('');
    setHeatingVoltage('');
    setHeatingTemperature('');
    setCoolingFunction('');
    setCoolingPower('');
    setCoolingVoltage('');
    setCoolingTemperature('');
    setSupplyAirSensor('');
    setFreshAirSensor('');
    setReturnAirSensor('');
    setExhaustAirSensor('');
    setMixedAirSensor('');
    setDehumidificationAirSensor('');
    setHeatExchangerAirSensor('');
    setFreshDamperActuator('');
    setSupplyDamperActuator('');
    setReturnDamperActuator('');
    setExhaustDamperActuator('');
    setMixedDamperActuator('');
    setReCirculationDamperActuator('');
    setRecuperatorDamperActuator('');
    setSupplyFilter('');
    setFreshFilter('');
    setReturnFilter('');
    setExhaustFilter('');
    setRecuperatorFilter('');
    setSupplyFlow('');
    setReturnFlow('');
    setRunAroundPumpControl('');
    setRunAroundPumpPieces('');
    setPumpPower('');
    setPumpVoltage('');
    setRunAroundTemperature('');
    setHeatRecoveryControl('');
    setHeatRecoveryPower('');
    setHeatRecoveryVoltage('');
    setHumidificationFunction('');
    setHumidificationPower('');
    setHumidificationVoltage('');
    setDehumidificationFunction('');
    setDehumidificationPower('');
    setDehumidificationVoltage('');
    setFanIntegration('');
    setFanProtocolIntegration('');
    setFanIntegrationPoints('');
    setRunAroundPumpIntegration('');
    setRunAroundPumpProtocolIntegration('');
    setRunAroundPumpIntegrationPoints('');
    setHeatExchangerIntegration('');
    setHeatExchangerProtocolIntegration('');
    setHeatExchangerIntegrationPoints('');
    setHumidificationIntegration('');
    setHumidificationProtocolIntegration('');
    setHumidificationIntegrationPoints('');
    setDehumidificationIntegration('');
    setDehumidificationProtocolIntegration('');
    setDehumidificationIntegrationPoints('');
  }
};



  const handleSaveAhu = () => {

       setTableRows([]);
    

const ahuControlPackagedRows: any[] = [];

// 1. Statuses / Command satırları
if (
  ahucontrolpackagedhardpoints === 'Statuses' ||
  ahucontrolpackagedhardpoints === 'Statuses and Command'
) {
  ahuControlPackagedRows.push(
    {
      point: 'Ahu Packaged System General Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0,
      mbus: 0
    },
    {
      point: 'Ahu Packaged System General Fault',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0,
      mbus: 0
    }
  );
}

if (
  ahucontrolpackagedhardpoints === 'Command' ||
  ahucontrolpackagedhardpoints === 'Statuses and Command'
) {
  ahuControlPackagedRows.push({
    point: 'Ahu Packaged System General Command',
    ai: 0, ao: 0, di: 0, do: 1,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0,
    mbus: 0
  });
}

// 2. Protokol satırı yalnızca doluysa eklenmeli ✅
if (
  ahucontrolpackagedprotocolIntegration !== '' &&
  ahuControlPackagedPoints !== ''
) {
  const parsedPoints = parseInt(ahuControlPackagedPoints) || 0;

  const protocol = {
    modbusRtu: 0,
    modbusTcp: 0,
    bacnetMstp: 0,
    bacnetIp: 0
  };

  switch (ahucontrolpackagedprotocolIntegration) {
    case 'Modbus RTU':
      protocol.modbusRtu = parsedPoints;
      break;
    case 'Modbus TCP IP':
      protocol.modbusTcp = parsedPoints;
      break;
    case 'Bacnet MSTP':
      protocol.bacnetMstp = parsedPoints;
      break;
    case 'Bacnet IP':
      protocol.bacnetIp = parsedPoints;
      break;
  }

  ahuControlPackagedRows.push({
    point: 'Ahu Packaged System Integration Points',
    ai: 0, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: protocol.modbusRtu,
    modbusTcp: protocol.modbusTcp,
    bacnetMstp: protocol.bacnetMstp,
    bacnetIp: protocol.bacnetIp,
    mbus: 0
  });
}

    let vantrows: any[] = [];
const vantpieces = Number(vantPieces);

if (!(ahuControl === 'MCC' && vantControl && vantpieces)) {
  vantrows = [];
} else {}

    if (vantControl === 'DOL' || vantControl === 'Star-Delta') {
  const dolRows = [
    { point: 'Vantilator Fan Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Command', ai: 0, ao: 0, di: 0, do: 1 }
  ];

  for (let i = 1; i <= vantpieces; i++) {
    const suffix = vantpieces > 1 ? ` ${i}` : '';
    dolRows.forEach((row) => {
      vantrows.push({
      projectCode,
      description,
      location,
      point: `${row.point}${suffix}`,
      ai: row.ai,
      ao: row.ao,
      di: row.di,
      do: row.do,
      modbusRtu: 0,
      modbusTcp: 0,
      bacnetMstp: 0,
      bacnetIp: 0,
      mbus: 0
      });
    });
  }
}

    if (vantControl === 'VFD') {
  const vfdRows = [
    { point: 'Vantilator Fan Frequency Inverter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Frequency Inverter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Frequency Inverter Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Frequency Inverter Command', ai: 0, ao: 0, di: 0, do: 1 },
    { point: 'Vantilator Fan Frequency Inverter Proportional Control', ai: 0, ao: 1, di: 0, do: 0 },
    { point: 'Vantilator Fan Frequency Inverter Feedback', ai: 1, ao: 0, di: 0, do: 0 }
  ];

  for (let i = 1; i <= vantpieces; i++) {
    const suffix = vantpieces > 1 ? ` ${i}` : '';
    vfdRows.forEach((row) => {
      vantrows.push({
      projectCode,
      description,
      location,
      point: `${row.point}${suffix}`,
      ai: row.ai,
      ao: row.ao,
      di: row.di,
      do: row.do,
      modbusRtu: 0,
      modbusTcp: 0,
      bacnetMstp: 0,
      bacnetIp: 0,
      mbus: 0
});
    });
  }
}

    if (vantControl === 'VFD with By Pass Circuit' || vantControl === 'VFD with By Pass Circuit + Star-Delta') {
      const byPassRows = [
          { point: 'Vantilator Fan Frequency Inverter Status', ai: 0, ao: 0, di: 1, do: 0 },
          { point: 'Vantilator Fan Contactor Status', ai: 0, ao: 0, di: 1, do: 0 },
          { point: 'Vantilator Fan Frequency Inverter Fault', ai: 0, ao: 0, di: 1, do: 0 },
          { point: 'Vantilator Fan Circuit Breaker Fault', ai: 0, ao: 0, di: 1, do: 0 },
          { point: 'Vantilator Fan Frequency Inverter Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
          { point: 'Vantilator Fan By/Pass Switch', ai: 0, ao: 0, di: 1, do: 0 },
          { point: 'Vantilator Fan Frequency Inverter Command', ai: 0, ao: 0, di: 0, do: 1 },
          { point: 'Vantilator Fan Frequency Inverter Proportional Control', ai: 0, ao: 1, di: 0, do: 0 },
          { point: 'Vantilator Fan Frequency Inverter Feedback', ai: 1, ao: 0, di: 0, do: 0 }
        ];

    for (let i = 1; i <= vantpieces; i++) {
      byPassRows.forEach(item => {
        vantrows.push({
          projectCode,
          description,
          location,
          point: vantpieces > 1 ? `${item.point} ${i}` : item.point,
          ai: item.ai,
          ao: item.ao,
          di: item.di,
          do: item.do,
          modbusRtu: 0,
          modbusTcp: 0,
          bacnetMstp: 0,
          bacnetIp: 0,
          mbus: 0
        });
      });
    }
  }

if (vantControl === 'Soft Starter') { 
  const softStarterRows = [
    { point: 'Vantilator Fan Soft Starter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Soft Starter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Soft Starter Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Soft Starter Command', ai: 0, ao: 0, di: 0, do: 1 }
  ];

  for (let i = 1; i <= vantpieces; i++) {
    const suffix = vantpieces > 1 ? ` ${i}` : '';
    softStarterRows.forEach((row) => {
      vantrows.push({
      projectCode,
      description,
      location,
      point: `${row.point}${suffix}`,
      ai: row.ai,
      ao: row.ao,
      di: row.di,
      do: row.do,
      modbusRtu: 0,
      modbusTcp: 0,
      bacnetMstp: 0,
      bacnetIp: 0,
      mbus: 0
});
    });
  }
}

if (vantControl === 'Soft Starter with By Pass Circuit'|| vantControl === 'Soft Starter with By Pass Circuit + Star-Delta') {
  const softBypassRows = [
    { point: 'Vantilator Fan Soft Starter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Contactor Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Soft Starter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Circuit Breaker Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Soft Starter Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan By Pass Switch Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator Fan Soft Starter Command', ai: 0, ao: 0, di: 0, do: 1 }
  ];

  for (let i = 1; i <= vantpieces; i++) {
    const suffix = vantpieces > 1 ? ` ${i}` : '';
    softBypassRows.forEach((row) => {
      vantrows.push({
        projectCode,
        description,
        location,
        point: `${row.point}${suffix}`,
        ai: row.ai,
        ao: row.ao,
        di: row.di,
        do: row.do,
        modbusRtu: 0,
        modbusTcp: 0,
        bacnetMstp: 0,
        bacnetIp: 0,
        mbus: 0
      });
    });
  }
}

if (vantControl === 'EC') {
  const ecRows = [
    { point: 'Vantilator EC Fan Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator EC Fan Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Vantilator EC Fan Proportional Control', ai: 0, ao: 1, di: 0, do: 0 },
    { point: 'Vantilator EC Fan Feedback', ai: 1, ao: 0, di: 0, do: 0 },
    { point: 'Vantilator EC Fan Command', ai: 0, ao: 0, di: 0, do: 1 }
  ];

  for (let i = 1; i <= vantpieces; i++) {
    const suffix = vantpieces > 1 ? ` ${i}` : '';
    ecRows.forEach((row) => {
      vantrows.push({
        projectCode,
        description,
        location,
        point: `${row.point}${suffix}`,
        ai: row.ai,
        ao: row.ao,
        di: row.di,
        do: row.do,
        modbusRtu: 0,
        modbusTcp: 0,
        bacnetMstp: 0,
        bacnetIp: 0,
        mbus: 0
      });
    });
  }
}



let asprows: any[] = [];
const asppieces = Number(aspPieces);

if (ahuControl === 'MCC' && aspControl && aspControl !== 'none' && asppieces > 0) {

if (aspControl === 'DOL' || aspControl === 'Star-Delta') {
  const dolRows = [
    { point: 'Aspirator Fan Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Command', ai: 0, ao: 0, di: 0, do: 1 }
  ];

  for (let i = 1; i <= asppieces; i++) {
    const suffix = asppieces > 1 ? ` ${i}` : '';
    dolRows.forEach((row) => {
      asprows.push({
  projectCode,
  description,
  location,
  point: `${row.point}${suffix}`,
  ai: row.ai,
  ao: row.ao,
  di: row.di,
  do: row.do,
  modbusRtu: 0,
  modbusTcp: 0,
  bacnetMstp: 0,
  bacnetIp: 0,
  mbus: 0
});
    });
  }
}

if (aspControl === 'VFD') {
  const vfdRows = [
    { point: 'Aspirator Fan Frequency Inverter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Frequency Inverter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Frequency Inverter Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Frequency Inverter Command', ai: 0, ao: 0, di: 0, do: 1 },
    { point: 'Aspirator Fan Frequency Inverter Proportional Control', ai: 0, ao: 1, di: 0, do: 0 },
    { point: 'Aspirator Fan Frequency Inverter Feedback', ai: 1, ao: 0, di: 0, do: 0 }
  ];

  for (let i = 1; i <= asppieces; i++) {
    const suffix = asppieces > 1 ? ` ${i}` : '';
    vfdRows.forEach((row) => {
      asprows.push({
        projectCode,
        description,
        location,
        point: `${row.point}${suffix}`,
        ai: row.ai,
        ao: row.ao,
        di: row.di,
        do: row.do,
        modbusRtu: 0,
        modbusTcp: 0,
        bacnetMstp: 0,
        bacnetIp: 0,
        mbus: 0
      });
    });
  }
}

if (aspControl === 'VFD with By Pass Circuit' || aspControl === 'VFD with By Pass Circuit + Star-Delta') {
  const byPassRows = [
    { point: 'Aspirator Fan Frequency Inverter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Contactor Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Frequency Inverter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Circuit Breaker Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Frequency Inverter Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan By/Pass Switch', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Frequency Inverter Command', ai: 0, ao: 0, di: 0, do: 1 },
    { point: 'Aspirator Fan Frequency Inverter Proportional Control', ai: 0, ao: 1, di: 0, do: 0 },
    { point: 'Aspirator Fan Frequency Inverter Feedback', ai: 1, ao: 0, di: 0, do: 0 }
  ];

  for (let i = 1; i <= asppieces; i++) {
    byPassRows.forEach(item => {
      asprows.push({
        projectCode,
        description,
        location,
        point: asppieces > 1 ? `${item.point} ${i}` : item.point,
        ai: item.ai,
        ao: item.ao,
        di: item.di,
        do: item.do,
        modbusRtu: 0,
        modbusTcp: 0,
        bacnetMstp: 0,
        bacnetIp: 0,
        mbus: 0
      });
    });
  }
}

if (aspControl === 'Soft Starter') {
  const softStarterRows = [
    { point: 'Aspirator Fan Soft Starter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Soft Starter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Soft Starter Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Soft Starter Command', ai: 0, ao: 0, di: 0, do: 1 }
  ];

  for (let i = 1; i <= asppieces; i++) {
    const suffix = asppieces > 1 ? ` ${i}` : '';
    softStarterRows.forEach((row) => {
      asprows.push({
  projectCode,
  description,
  location,
  point: `${row.point}${suffix}`,
  ai: row.ai,
  ao: row.ao,
  di: row.di,
  do: row.do,
  modbusRtu: 0,
  modbusTcp: 0,
  bacnetMstp: 0,
  bacnetIp: 0,
  mbus: 0
});
    });
  }
}

if (aspControl === 'Soft Starter with By Pass Circuit' || aspControl === 'Soft Starter with By Pass Circuit + Star-Delta') {
  const softBypassRows = [
    { point: 'Aspirator Fan Soft Starter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Contactor Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Soft Starter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Circuit Breaker Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Soft Starter Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan By/Pass Switch Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator Fan Soft Starter Command', ai: 0, ao: 0, di: 0, do: 1 }
  ];

  for (let i = 1; i <= asppieces; i++) {
    const suffix = asppieces > 1 ? ` ${i}` : '';
    softBypassRows.forEach((row) => {
      asprows.push({
        projectCode,
        description,
        location,
        point: `${row.point}${suffix}`,
        ai: row.ai,
        ao: row.ao,
        di: row.di,
        do: row.do,
        modbusRtu: 0,
        modbusTcp: 0,
        bacnetMstp: 0,
        bacnetIp: 0,
        mbus: 0
      });
    });
  }
}



if (aspControl === 'EC') {
  const ecRows = [
    { point: 'Aspirator EC Fan Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator EC Fan Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Aspirator EC Fan Proportional Control', ai: 0, ao: 1, di: 0, do: 0 },
    { point: 'Aspirator EC Fan Feedback', ai: 1, ao: 0, di: 0, do: 0 },
    { point: 'Aspirator EC Fan Command', ai: 0, ao: 0, di: 0, do: 1 }
  ];

  for (let i = 1; i <= asppieces; i++) {
    const suffix = asppieces > 1 ? ` ${i}` : '';
    ecRows.forEach((row) => {
      asprows.push({
        projectCode,
        description,
        location,
        point: `${row.point}${suffix}`,
        ai: row.ai,
        ao: row.ao,
        di: row.di,
        do: row.do,
        modbusRtu: 0,
        modbusTcp: 0,
        bacnetMstp: 0,
        bacnetIp: 0,
        mbus: 0
      });
    });
  }
  
}
}


const maintenanceRows: any[] = [];

if (maintenanceSafety === 'for Each Fan') {
  if (vantControl !== 'none') {
    for (let i = 1; i <= vantpieces; i++) {
      maintenanceRows.push({
        point: `Vantilator Fan Maintenance Status${vantpieces > 1 ? ` ${i}` : ''}`,
        ai: 0, ao: 0, di: 1, do: 0,
        projectCode, description, location,
        modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
      });
    }
  }

  if (aspControl !== 'none') {
    for (let i = 1; i <= asppieces; i++) {
      maintenanceRows.push({
        point: `Aspirator Fan Maintenance Status${asppieces > 1 ? ` ${i}` : ''}`,
        ai: 0, ao: 0, di: 1, do: 0,
        projectCode, description, location,
        modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
      });
    }
  }
}

if (maintenanceSafety === 'for All Fans') {
  if (vantControl !== 'none') {
    maintenanceRows.push({
      point: 'Vantilator General Maintenance Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    });
  }

  if (aspControl !== 'none') {
    maintenanceRows.push({
      point: 'Aspirator General Maintenance Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    });
  }
}

const emergencyRows: any[] = [];

if (emergencySafety === 'for Each Fan') {
  if (vantControl !== 'none') {
    for (let i = 1; i <= vantpieces; i++) {
      emergencyRows.push({
        point: `Vantilator Fan Emergency Status${vantpieces > 1 ? ` ${i}` : ''}`,
        ai: 0, ao: 0, di: 1, do: 0,
        projectCode, description, location,
        modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
      });
    }
  }

  if (aspControl !== 'none') {
    for (let i = 1; i <= asppieces; i++) {
      emergencyRows.push({
        point: `Aspirator Fan Emergency Status${asppieces > 1 ? ` ${i}` : ''}`,
        ai: 0, ao: 0, di: 1, do: 0,
        projectCode, description, location,
        modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
      });
    }
  }
}

if (emergencySafety === 'for All Fans') {
  if (vantControl !== 'none') {
    emergencyRows.push({
      point: 'Vantilator General Emergency Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    });
  }

  if (aspControl !== 'none') {
    emergencyRows.push({
      point: 'Aspirator General Emergency Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    });
  }
}

const doorRows: any[] = [];

if (doorSafety === 'for Each Fan') {
  if (vantControl !== 'none') {
    for (let i = 1; i <= vantpieces; i++) {
      doorRows.push({
        point: `Vantilator Fan Door Status${vantpieces > 1 ? ` ${i}` : ''}`,
        ai: 0, ao: 0, di: 1, do: 0,
        projectCode, description, location,
        modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
      });
    }
  }

  if (aspControl !== 'none') {
    for (let i = 1; i <= asppieces; i++) {
      doorRows.push({
        point: `Aspirator Fan Door Status${asppieces > 1 ? ` ${i}` : ''}`,
        ai: 0, ao: 0, di: 1, do: 0,
        projectCode, description, location,
        modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
      });
    }
  }
}

if (doorSafety === 'for All Fans') {
  if (vantControl !== 'none') {
    doorRows.push({
      point: 'Vantilator General Door Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    });
  }

  if (aspControl !== 'none') {
    doorRows.push({
      point: 'Aspirator General Door Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    });
  }
}

const fireRows: any[] = [];

if (fireSafety === 'only Viewing') {
  fireRows.push({
    point: 'Vantilator Fan Fire Status',
    ai: 0, ao: 0, di: 1, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (fireSafety === 'Viewing and Control') {
  fireRows.push({
    point: 'Vantilator Fan Fire Status',
    ai: 0, ao: 0, di: 1, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });

  if (aspControl !== 'none') {
    fireRows.push({
      point: 'Aspirator Fan Fire Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    });
  }
}

const frostRows: any[] = [];

if (frostSafety === 'Automatic Reset' || frostSafety === 'Manual Reset') {
  frostRows.push({
    point: 'Frost Thermostat Status',
    ai: 0, ao: 0, di: 1, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

const preheatingRows: any[] = [];

if (preheatingFunction === 'On/Off Valve Actuator') {
  preheatingRows.push(
    {
      point: 'Preheating Valve Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    
  );
}

if (preheatingFunction === 'On/Off Valve Actuator with Feedback') {
  preheatingRows.push(
    {
      point: 'Preheating Valve Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    
    {
      point: 'Preheating Valve Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    
  );
}

if (preheatingFunction === 'Floating Valve Actuator') {
  preheatingRows.push(
   {
      point: 'Preheating Valve Open Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Preheating Valve Close Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    
  );
}

if (preheatingFunction === 'Floating Valve Actuator with Feedback') {
  preheatingRows.push(
    {
      point: 'Preheating Valve Open Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Preheating Valve Close Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Preheating Valve Open Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Preheating Valve Close Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}


if (preheatingFunction === 'Proportional Valve Actuator') {
  preheatingRows.push({
    point: 'Preheating Valve Proportional Command',
    ai: 0, ao: 1, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (preheatingFunction === 'Proportional Valve Actuator with Feedback') {
  preheatingRows.push(
    {
      point: 'Preheating Valve Proportional Command',
      ai: 0, ao: 1, di: 0, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Preheating Valve Proportional Feedback',
      ai: 1, ao: 0, di: 0, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (preheatingFunction === '1-Staged Electrical Heater') {
  preheatingRows.push(
    { point: 'Preheating Electrical Heater Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater Air Flow', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }

  );
}

if (preheatingFunction === '2-Staged Electrical Heater') {
  preheatingRows.push(
    { point: 'Preheating Electrical Heater-1 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater-1 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater-1 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater-2 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater-2 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater-2 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater Air Flow', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (preheatingFunction === '3-Staged Electrical Heater') {
  preheatingRows.push(
    { point: 'Preheating Electrical Heater-1 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater-1 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater-1 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater-2 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater-2 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater-2 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater-3 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater-3 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater-3 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Electrical Heater Air Flow', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (preheatingFunction === 'Proportional Electrical Heater') {
  preheatingRows.push(
    { point: 'Preheating Proportional Electrical Heater Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Proportional Electrical Heater Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Proportional Electrical Heater Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Proportional Electrical Heater Proportional Control', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Preheating Proportional Electrical Heater Feedback', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

const preheatingTemperatureRows: any[] = [];

if (preheatingTemperature === 'Inlet Temperature') {
  preheatingTemperatureRows.push({
    point: 'Preheating Coil Inlet Temperature',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (preheatingTemperature === 'Outlet Temperature') {
  preheatingTemperatureRows.push({
    point: 'Preheating Coil Outlet Temperature',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (preheatingTemperature === 'Inlet and Outlet Temperature') {
  preheatingTemperatureRows.push(
    {
      point: 'Preheating Coil Inlet Temperature',
      ai: 1, ao: 0, di: 0, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Preheating Coil Outlet Temperature',
      ai: 1, ao: 0, di: 0, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}


const heatingRows: any[] = [];

if (heatingFunction === 'On/Off Valve Actuator') {
  heatingRows.push(
    {
      point: 'Heating Valve Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
     
  );
}

if (heatingFunction === 'On/Off Valve Actuator with Feedback') {
  heatingRows.push(
    {
      point: 'Heating Valve Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    
    {
      point: 'Heating Valve Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    
  );
}

if (heatingFunction === 'Floating Valve Actuator') {
  heatingRows.push(
   {
      point: 'Heating Valve Open Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Heating Valve Close Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    
  );
}

if (heatingFunction === 'Floating Valve Actuator with Feedback') {
  heatingRows.push(
    {
      point: 'Heating Valve Open Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Heating Valve Close Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Heating Valve Open Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Heating Valve Close Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (heatingFunction === 'Proportional Valve Actuator') {
  heatingRows.push({
    point: 'Heating Valve Proportional Command',
    ai: 0, ao: 1, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (heatingFunction === 'Proportional Valve Actuator with Feedback') {
  heatingRows.push(
    {
      point: 'Heating Valve Proportional Command',
      ai: 0, ao: 1, di: 0, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Heating Valve Proportional Feedback',
      ai: 1, ao: 0, di: 0, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (heatingFunction === '1-Staged Electrical Heater') {
  heatingRows.push(
    { point: 'Heating Electrical Heater Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater Air Flow', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }

  );
}

if (heatingFunction === '2-Staged Electrical Heater') {
  heatingRows.push(
    { point: 'Heating Electrical Heater-1 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater-1 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater-1 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater-2 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater-2 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater-2 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater Air Flow', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (heatingFunction === '3-Staged Electrical Heater') {
  heatingRows.push(
    { point: 'Heating Electrical Heater-1 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater-1 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater-1 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater-2 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater-2 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater-2 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater-3 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater-3 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater-3 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Electrical Heater Air Flow', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (heatingFunction === 'Proportional Electrical Heater') {
  heatingRows.push(
    { point: 'Heating Proportional Electrical Heater Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Proportional Electrical Heater Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Proportional Electrical Heater Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Proportional Electrical Heater Proportional Control', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heating Proportional Electrical Heater Feedback', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

const heatingTemperatureRows: any[] = [];

if (heatingTemperature === 'Inlet Temperature') {
  heatingTemperatureRows.push({
    point: 'Heating Coil Inlet Temperature',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (heatingTemperature === 'Outlet Temperature') {
  heatingTemperatureRows.push({
    point: 'Heating Coil Outlet Temperature',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (heatingTemperature === 'Inlet and Outlet Temperature') {
  heatingTemperatureRows.push(
    {
      point: 'Heating Coil Inlet Temperature',
      ai: 1, ao: 0, di: 0, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Heating Coil Outlet Temperature',
      ai: 1, ao: 0, di: 0, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}


const coolingRows: any[] = [];

if (coolingFunction === 'On/Off Valve Actuator') {
  coolingRows.push(
    {
      point: 'Cooling Valve Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (coolingFunction === 'On/Off Valve Actuator with Feedback') {
  coolingRows.push(
    {
      point: 'Cooling Valve Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Cooling Valve Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (coolingFunction === 'Floating Valve Actuator') {
  coolingRows.push(
   {
      point: 'Cooling Valve Open Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Cooling Valve Close Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
    
  );
}

if (coolingFunction === 'Floating Valve Actuator with Feedback') {
  coolingRows.push(
    {
      point: 'Cooling Valve Open Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Cooling Valve Close Command',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Cooling Valve Open Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Cooling Valve Close Status',
      ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}



if (coolingFunction === 'Proportional Valve Actuator') {
  coolingRows.push({
    point: 'Cooling Valve Proportional Command',
    ai: 0, ao: 1, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (coolingFunction === 'Proportional Valve Actuator with Feedback') {
  coolingRows.push(
    {
      point: 'Cooling Valve Proportional Command',
      ai: 0, ao: 1, di: 0, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Cooling Valve Proportional Feedback',
      ai: 1, ao: 0, di: 0, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (coolingFunction === '1-Staged DX Unit') {
  coolingRows.push(
    { point: 'Cooling DX Unit Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
    

  );
}

if (coolingFunction === '2-Staged DX Unit') {
  coolingRows.push(
    { point: 'Cooling DX Unit-1 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit-1 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit-1 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit-2 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit-2 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit-2 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (coolingFunction === '3-Staged DX Unit') {
  coolingRows.push(
    { point: 'Cooling DX Unit-1 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit-1 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit-1 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit-2 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit-2 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit-2 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit-3 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit-3 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit-3 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (coolingFunction === 'Proportional DX Unit') {
  coolingRows.push(
    { point: 'Cooling DX Unit Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit Proportional Control', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Cooling DX Unit Feedback', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

const coolingTemperatureRows: any[] = [];

if (coolingTemperature === 'Inlet Temperature') {
  coolingTemperatureRows.push({
    point: 'Cooling Coil Inlet Temperature',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (coolingTemperature === 'Outlet Temperature') {
  coolingTemperatureRows.push({
    point: 'Cooling Coil Outlet Temperature',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (coolingTemperature === 'Inlet and Outlet Temperature') {
  coolingTemperatureRows.push(
    {
      point: 'Cooling Coil Inlet Temperature',
      ai: 1, ao: 0, di: 0, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Cooling Coil Outlet Temperature',
      ai: 1, ao: 0, di: 0, do: 0,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

const supplyAirSensorRows: any[] = [];

if (supplyAirSensor === 'Temperature') {
  supplyAirSensorRows.push({
    point: 'Supply Air Temperature',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (supplyAirSensor === 'Humidity') {
  supplyAirSensorRows.push({
    point: 'Supply Air Humidity',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (supplyAirSensor === 'Temperature and Humidity') {
  supplyAirSensorRows.push({
    point: 'Supply Air Temperature and Humidity',
    ai: 2, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

const freshAirSensorRows: any[] = [];

if (freshAirSensor === 'Temperature') {
  freshAirSensorRows.push({
    point: 'Fresh Air Temperature',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (freshAirSensor === 'Humidity') {
  freshAirSensorRows.push({
    point: 'Fresh Air Humidity',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (freshAirSensor === 'Temperature and Humidity') {
  freshAirSensorRows.push({
    point: 'Fresh Air Temperature and Humidity',
    ai: 2, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

const returnAirSensorRows: any[] = [];

if (returnAirSensor === 'Temperature') {
  returnAirSensorRows.push({
    point: 'Return Air Temperature',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (returnAirSensor === 'Humidity') {
  returnAirSensorRows.push({
    point: 'Return Air Humidity',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (returnAirSensor === 'Co2') {
  returnAirSensorRows.push({
    point: 'Return Air Co2',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (returnAirSensor === 'Temperature and Humidity') {
  returnAirSensorRows.push({
    point: 'Return Air Temperature and Humidity',
    ai: 2, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (returnAirSensor === 'Temperature, Humidity and Co2') {
  returnAirSensorRows.push({
    point: 'Return Air Temperature, Humidity and Co2',
    ai: 3, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}


const exhaustAirSensorRows: any[] = [];

if (exhaustAirSensor === 'Temperature') {
  exhaustAirSensorRows.push({
    point: 'Exhaust Air Temperature',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (exhaustAirSensor === 'Humidity') {
  exhaustAirSensorRows.push({
    point: 'Exhaust Air Humidity',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (exhaustAirSensor === 'Temperature and Humidity') {
  exhaustAirSensorRows.push({
    point: 'Exhaust Air Temperature and Humidity',
    ai: 2, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

const mixedAirSensorRows: any[] = [];

if (mixedAirSensor === 'Temperature') {
  mixedAirSensorRows.push({
    point: 'Mixed Air Temperature',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (mixedAirSensor === 'Humidity') {
  mixedAirSensorRows.push({
    point: 'Mixed Air Humidity',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (mixedAirSensor === 'Temperature and Humidity') {
  mixedAirSensorRows.push({
    point: 'Mixed Air Temperature and Humidity',
    ai: 2, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

const dehumidificationAirRows: any[] = [];

if (dehumidificationAirSensor === 'Temperature') {
  dehumidificationAirRows.push({
    point: 'Dehumidification Temperature',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0,
    bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (dehumidificationAirSensor === 'Humidity') {
  dehumidificationAirRows.push({
    point: 'Dehumidification Humidity',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0,
    bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
} else if (dehumidificationAirSensor === 'Temperature and Humidity') {
  dehumidificationAirRows.push({
    point: 'Dehumidification Temperature and Humidity',
    ai: 2, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0,
    bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

const heatExchangerAirRows: any[] = [];

if (heatExchangerAirSensor === 'Fresh Side Temperature') {
  heatExchangerAirRows.push(
    ...[
      {
        point: 'Heat Exchanger Fresh Side Inlet Temperature',
        ai: 1, ao: 0, di: 0, do: 0,
        projectCode, description, location,
        modbusRtu: 0, modbusTcp: 0,
        bacnetMstp: 0, bacnetIp: 0, mbus: 0
      },
      {
        point: 'Heat Exchanger Fresh Side Outlet Temperature',
        ai: 1, ao: 0, di: 0, do: 0,
        projectCode, description, location,
        modbusRtu: 0, modbusTcp: 0,
        bacnetMstp: 0, bacnetIp: 0, mbus: 0
      }
    ]
  );
} else if (heatExchangerAirSensor === 'Return Side Temperature') {
  heatExchangerAirRows.push(
    ...[
      {
        point: 'Heat Exchanger Return Side Inlet Temperature',
        ai: 1, ao: 0, di: 0, do: 0,
        projectCode, description, location,
        modbusRtu: 0, modbusTcp: 0,
        bacnetMstp: 0, bacnetIp: 0, mbus: 0
      },
      {
        point: 'Heat Exchanger Return Side Outlet Temperature',
        ai: 1, ao: 0, di: 0, do: 0,
        projectCode, description, location,
        modbusRtu: 0, modbusTcp: 0,
        bacnetMstp: 0, bacnetIp: 0, mbus: 0
      }
    ]
  );
} else if (heatExchangerAirSensor === 'Fresh and Return Side Temperature') {
  heatExchangerAirRows.push(
    ...[
      {
        point: 'Heat Exchanger Fresh Side Inlet Temperature', 
        ai: 1, ao: 0, di: 0, do: 0, 
        projectCode, description, location, modbusRtu: 0, modbusTcp: 0, 
        bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
      {
        point: 'Heat Exchanger Fresh Side Outlet Temperature', 
        ai: 1, ao: 0, di: 0, do: 0, 
        projectCode, description, location, modbusRtu: 0, modbusTcp: 0, 
        bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
      {
        point: 'Heat Exchanger Return Side Inlet Temperature', 
        ai: 1, ao: 0, di: 0, do: 0, 
        projectCode, description, location, modbusRtu: 0, modbusTcp: 0, 
        bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
      {
        point: 'Heat Exchanger Return Side Outlet Temperature', 
        ai: 1, ao: 0, di: 0, do: 0, 
        projectCode, description, location, modbusRtu: 0, modbusTcp: 0, 
        bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
      ]);
      }

      const freshDamperRows: any[] = [];

if (freshDamperActuator === 'none') {

}

if (freshDamperActuator === 'On/Off Damper Actuator') {
  freshDamperRows.push({
    point: 'Fresh Air On/Off Damper Actuator Command', ai: 0, ao: 0, di: 0, do: 1,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshDamperActuator === 'On/Off Damper Actuator with Feedback') {
  freshDamperRows.push(
    { point: 'Fresh Air On/Off Damper Actuator Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air On/Off Damper Actuator Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (freshDamperActuator === 'Floating Damper Actuator') {
  freshDamperRows.push(
    { point: 'Fresh Air Floating Damper Actuator Open Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Close Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (freshDamperActuator === 'Floating Damper Actuator with Feedback') {
  freshDamperRows.push(
    { point: 'Fresh Air Floating Damper Actuator Open Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Close Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Open Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Close Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (freshDamperActuator === 'Proportional Damper Actuator') {
  freshDamperRows.push({
    point: 'Fresh Air Proportional Damper Actuator Command', ai: 0, ao: 1, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshDamperActuator === 'Proportional Damper Actuator with Feedback') {
  freshDamperRows.push(
    { point: 'Fresh Air Proportional Damper Actuator Command', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Proportional Damper Actuator Feedback', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (freshDamperActuator === '2x On/Off Damper Actuator') {
  freshDamperRows.push(
    { point: 'Fresh Air On/Off Damper Actuator Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air On/Off Damper Actuator Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (freshDamperActuator === '2x On/Off Damper Actuator with Feedback') {
  freshDamperRows.push(
    { point: 'Fresh Air On/Off Damper Actuator Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air On/Off Damper Actuator Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air On/Off Damper Actuator Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air On/Off Damper Actuator Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (freshDamperActuator === '2x Floating Damper Actuator') {
  freshDamperRows.push(
    { point: 'Fresh Air Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (freshDamperActuator === '2x Floating Damper Actuator with Feedback') {
  freshDamperRows.push(
    { point: 'Fresh Air Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Open Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Close Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Open Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Floating Damper Actuator Close Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (freshDamperActuator === '2x Proportional Damper Actuator') {
  freshDamperRows.push(
    { point: 'Fresh Air Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (freshDamperActuator === '2x Proportional Damper Actuator with Feedback') {
  freshDamperRows.push(
    { point: 'Fresh Air Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Proportional Damper Actuator Feedback-1', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Fresh Air Proportional Damper Actuator Feedback-2', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}


const supplyDamperRows: any[] = [];



if (supplyDamperActuator === 'none') {

}

if (supplyDamperActuator === 'On/Off Damper Actuator') {
  supplyDamperRows.push({
    point: 'Supply Air On/Off Damper Actuator Command', ai: 0, ao: 0, di: 0, do: 1,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyDamperActuator === 'On/Off Damper Actuator with Feedback') {
  supplyDamperRows.push(
    { point: 'Supply Air On/Off Damper Actuator Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air On/Off Damper Actuator Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (supplyDamperActuator === 'Floating Damper Actuator') {
  supplyDamperRows.push(
    { point: 'Supply Air Floating Damper Actuator Open Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Close Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (supplyDamperActuator === 'Floating Damper Actuator with Feedback') {
  supplyDamperRows.push(
    { point: 'Supply Air Floating Damper Actuator Open Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Close Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Open Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Close Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (supplyDamperActuator === 'Proportional Damper Actuator') {
  supplyDamperRows.push({
    point: 'Supply Air Proportional Damper Actuator Command', ai: 0, ao: 1, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyDamperActuator === 'Proportional Damper Actuator with Feedback') {
  supplyDamperRows.push(
    { point: 'Supply Air Proportional Damper Actuator Command', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Proportional Damper Actuator Feedback', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (supplyDamperActuator === '2x On/Off Damper Actuator') {
  supplyDamperRows.push(
    { point: 'Supply Air On/Off Damper Actuator Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air On/Off Damper Actuator Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (supplyDamperActuator === '2x On/Off Damper Actuator with Feedback') {
  supplyDamperRows.push(
    { point: 'Supply Air On/Off Damper Actuator Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air On/Off Damper Actuator Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air On/Off Damper Actuator Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air On/Off Damper Actuator Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (supplyDamperActuator === '2x Floating Damper Actuator') {
  supplyDamperRows.push(
    { point: 'Supply Air Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (supplyDamperActuator === '2x Floating Damper Actuator with Feedback') {
  supplyDamperRows.push(
    { point: 'Supply Air Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Open Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Close Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Open Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Floating Damper Actuator Close Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (supplyDamperActuator === '2x Proportional Damper Actuator') {
  supplyDamperRows.push(
    { point: 'Supply Air Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (supplyDamperActuator === '2x Proportional Damper Actuator with Feedback') {
  supplyDamperRows.push(
    { point: 'Supply Air Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Proportional Damper Actuator Feedback-1', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Supply Air Proportional Damper Actuator Feedback-2', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}


const returnDamperRows: any[] = [];

if (returnDamperActuator === 'none') {

}

if (returnDamperActuator === 'On/Off Damper Actuator') {
  returnDamperRows.push({
    point: 'Return Air On/Off Damper Actuator Command', ai: 0, ao: 0, di: 0, do: 1,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (returnDamperActuator === 'On/Off Damper Actuator with Feedback') {
  returnDamperRows.push(
    { point: 'Return Air On/Off Damper Actuator Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air On/Off Damper Actuator Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (returnDamperActuator === 'Floating Damper Actuator') {
  returnDamperRows.push(
    { point: 'Return Air Floating Damper Actuator Open Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Close Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (returnDamperActuator === 'Floating Damper Actuator with Feedback') {
  returnDamperRows.push(
    { point: 'Return Air Floating Damper Actuator Open Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Close Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Open Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Close Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (returnDamperActuator === 'Proportional Damper Actuator') {
  returnDamperRows.push({
    point: 'Return Air Proportional Damper Actuator Command', ai: 0, ao: 1, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (returnDamperActuator === 'Proportional Damper Actuator with Feedback') {
  returnDamperRows.push(
    { point: 'Return Air Proportional Damper Actuator Command', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Proportional Damper Actuator Feedback', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (returnDamperActuator === '2x On/Off Damper Actuator') {
  returnDamperRows.push(
    { point: 'Return Air On/Off Damper Actuator Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air On/Off Damper Actuator Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (returnDamperActuator === '2x On/Off Damper Actuator with Feedback') {
  returnDamperRows.push(
    { point: 'Return Air On/Off Damper Actuator Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air On/Off Damper Actuator Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air On/Off Damper Actuator Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air On/Off Damper Actuator Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (returnDamperActuator === '2x Floating Damper Actuator') {
  returnDamperRows.push(
    { point: 'Return Air Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (returnDamperActuator === '2x Floating Damper Actuator with Feedback') {
  returnDamperRows.push(
    { point: 'Return Air Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Open Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Close Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Open Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Floating Damper Actuator Close Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (returnDamperActuator === '2x Proportional Damper Actuator') {
  returnDamperRows.push(
    { point: 'Return Air Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (returnDamperActuator === '2x Proportional Damper Actuator with Feedback') {
  returnDamperRows.push(
    { point: 'Return Air Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Proportional Damper Actuator Feedback-1', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Return Air Proportional Damper Actuator Feedback-2', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}


const exhaustDamperRows: any[] = [];

if (exhaustDamperActuator === 'none') {
  // Hiçbir işlem yapılmaz
}

if (exhaustDamperActuator === 'On/Off Damper Actuator') {
  exhaustDamperRows.push({
    point: 'Exhaust Air On/Off Damper Actuator Command', ai: 0, ao: 0, di: 0, do: 1,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (exhaustDamperActuator === 'On/Off Damper Actuator with Feedback') {
  exhaustDamperRows.push(
    { point: 'Exhaust Air On/Off Damper Actuator Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air On/Off Damper Actuator Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (exhaustDamperActuator === 'Floating Damper Actuator') {
  exhaustDamperRows.push(
    { point: 'Exhaust Air Floating Damper Actuator Open Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Close Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (exhaustDamperActuator === 'Floating Damper Actuator with Feedback') {
  exhaustDamperRows.push(
    { point: 'Exhaust Air Floating Damper Actuator Open Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Close Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Open Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Close Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (exhaustDamperActuator === 'Proportional Damper Actuator') {
  exhaustDamperRows.push({
    point: 'Exhaust Air Proportional Damper Actuator Command', ai: 0, ao: 1, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (exhaustDamperActuator === 'Proportional Damper Actuator with Feedback') {
  exhaustDamperRows.push(
    { point: 'Exhaust Air Proportional Damper Actuator Command', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Proportional Damper Actuator Feedback', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (exhaustDamperActuator === '2x On/Off Damper Actuator') {
  exhaustDamperRows.push(
    { point: 'Exhaust Air On/Off Damper Actuator Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air On/Off Damper Actuator Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (exhaustDamperActuator === '2x On/Off Damper Actuator with Feedback') {
  exhaustDamperRows.push(
    { point: 'Exhaust Air On/Off Damper Actuator Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air On/Off Damper Actuator Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air On/Off Damper Actuator Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air On/Off Damper Actuator Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (exhaustDamperActuator === '2x Floating Damper Actuator') {
  exhaustDamperRows.push(
    { point: 'Exhaust Air Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (exhaustDamperActuator === '2x Floating Damper Actuator with Feedback') {
  exhaustDamperRows.push(
    { point: 'Exhaust Air Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Open Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Close Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Open Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Floating Damper Actuator Close Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (exhaustDamperActuator === '2x Proportional Damper Actuator') {
  exhaustDamperRows.push(
    { point: 'Exhaust Air Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (exhaustDamperActuator === '2x Proportional Damper Actuator with Feedback') {
  exhaustDamperRows.push(
    { point: 'Exhaust Air Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Proportional Damper Actuator Feedback-1', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Exhaust Air Proportional Damper Actuator Feedback-2', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}


const mixedDamperRows: any[] = [];

if (mixedDamperActuator === 'none') {

}

if (mixedDamperActuator === 'On/Off Damper Actuator') {
  mixedDamperRows.push({
    point: 'Mixed Air On/Off Damper Actuator Command', ai: 0, ao: 0, di: 0, do: 1,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (mixedDamperActuator === 'On/Off Damper Actuator with Feedback') {
  mixedDamperRows.push(
    { point: 'Mixed Air On/Off Damper Actuator Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air On/Off Damper Actuator Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (mixedDamperActuator === 'Floating Damper Actuator') {
  mixedDamperRows.push(
    { point: 'Mixed Air Floating Damper Actuator Open Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Close Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (mixedDamperActuator === 'Floating Damper Actuator with Feedback') {
  mixedDamperRows.push(
    { point: 'Mixed Air Floating Damper Actuator Open Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Close Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Open Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Close Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (mixedDamperActuator === 'Proportional Damper Actuator') {
  mixedDamperRows.push({
    point: 'Mixed Air Proportional Damper Actuator Command', ai: 0, ao: 1, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (mixedDamperActuator === 'Proportional Damper Actuator with Feedback') {
  mixedDamperRows.push(
    { point: 'Mixed Air Proportional Damper Actuator Command', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Proportional Damper Actuator Feedback', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (mixedDamperActuator === '2x On/Off Damper Actuator') {
  mixedDamperRows.push(
    { point: 'Mixed Air On/Off Damper Actuator Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air On/Off Damper Actuator Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (mixedDamperActuator === '2x On/Off Damper Actuator with Feedback') {
  mixedDamperRows.push(
    { point: 'Mixed Air On/Off Damper Actuator Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air On/Off Damper Actuator Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air On/Off Damper Actuator Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air On/Off Damper Actuator Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (mixedDamperActuator === '2x Floating Damper Actuator') {
  mixedDamperRows.push(
    { point: 'Mixed Air Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (mixedDamperActuator === '2x Floating Damper Actuator with Feedback') {
  mixedDamperRows.push(
    { point: 'Mixed Air Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Open Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Close Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Open Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Floating Damper Actuator Close Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (mixedDamperActuator === '2x Proportional Damper Actuator') {
  mixedDamperRows.push(
    { point: 'Mixed Air Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (mixedDamperActuator === '2x Proportional Damper Actuator with Feedback') {
  mixedDamperRows.push(
    { point: 'Mixed Air Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Proportional Damper Actuator Feedback-1', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Mixed Air Proportional Damper Actuator Feedback-2', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}


const reCirculationDamperRows: any[] = [];

if (reCirculationDamperActuator === 'On/Off Damper Actuator') {
  reCirculationDamperRows.push({
    point: 'Re Circulation Air On/Off Damper Actuator Command', ai: 0, ao: 0, di: 0, do: 1,
    projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (reCirculationDamperActuator === 'On/Off Damper Actuator with Feedback') {
  reCirculationDamperRows.push(
    { point: 'Re Circulation Air On/Off Damper Actuator Command', ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air On/Off Damper Actuator Status', ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (reCirculationDamperActuator === 'Floating Damper Actuator') {
  reCirculationDamperRows.push(
    { point: 'Re Circulation Air Floating Damper Actuator Open Command', ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Close Command', ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (reCirculationDamperActuator === 'Floating Damper Actuator with Feedback') {
  reCirculationDamperRows.push(
    { point: 'Re Circulation Air Floating Damper Actuator Open Command', ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Close Command', ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Open Status', ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Close Status', ai: 0, ao: 0, di: 1, do: 0,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (reCirculationDamperActuator === 'Proportional Damper Actuator') {
  reCirculationDamperRows.push({
    point: 'Re Circulation Air Proportional Damper Actuator Command', ai: 0, ao: 1, di: 0, do: 0,
    projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (reCirculationDamperActuator === 'Proportional Damper Actuator with Feedback') {
  reCirculationDamperRows.push(
    { point: 'Re Circulation Air Proportional Damper Actuator Command', ai: 0, ao: 1, di: 0, do: 0,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Proportional Damper Actuator Feedback', ai: 1, ao: 0, di: 0, do: 0,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (reCirculationDamperActuator === '2x On/Off Damper Actuator') {
  reCirculationDamperRows.push(
    { point: 'Re Circulation Air On/Off Damper Actuator Command-1', ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air On/Off Damper Actuator Command-2', ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (reCirculationDamperActuator === '2x On/Off Damper Actuator with Feedback') {
  reCirculationDamperRows.push(
    { point: 'Re Circulation Air On/Off Damper Actuator Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air On/Off Damper Actuator Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air On/Off Damper Actuator Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air On/Off Damper Actuator Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (reCirculationDamperActuator === '2x Floating Damper Actuator') {
  reCirculationDamperRows.push(
    { point: 'Re Circulation Air Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (reCirculationDamperActuator === '2x Floating Damper Actuator with Feedback') {
  reCirculationDamperRows.push(
    { point: 'Re Circulation Air Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Open Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Close Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Open Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Floating Damper Actuator Close Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (reCirculationDamperActuator === '2x Proportional Damper Actuator') {
  reCirculationDamperRows.push(
    { point: 'Re Circulation Air Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (reCirculationDamperActuator === '2x Proportional Damper Actuator with Feedback') {
  reCirculationDamperRows.push(
    { point: 'Re Circulation Air Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Proportional Damper Actuator Feedback-1', ai: 1, ao: 0, di: 0, do: 0,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Re Circulation Air Proportional Damper Actuator Feedback-2', ai: 1, ao: 0, di: 0, do: 0,
      projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}


const recuperatorDamperRows: any[] = [];

if (recuperatorDamperActuator === 'On/Off Damper Actuator') { recuperatorDamperRows.push({   point: 'Heat Exchanger On/Off Damper Actuator Command',   ai: 0, ao: 0, di: 0, do: 1,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (recuperatorDamperActuator === 'On/Off Damper Actuator with Feedback') { recuperatorDamperRows.push(   {  point: 'Heat Exchanger On/Off Damper Actuator Command',     ai: 0, ao: 0, di: 0, do: 1,     projectCode, description, location,     modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Heat Exchanger On/Off Damper Actuator Status',   ai: 0, ao: 0, di: 1, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (recuperatorDamperActuator === 'Floating Damper Actuator') {recuperatorDamperRows.push(  {   point: 'Heat Exchanger Floating Damper Actuator Open Command',    ai: 0, ao: 0, di: 0, do: 1,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Heat Exchanger Floating Damper Actuator Close Command',    ai: 0, ao: 0, di: 0, do: 1,    projectCode, description, location,    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (recuperatorDamperActuator === 'Floating Damper Actuator with Feedback') { recuperatorDamperRows.push(  {   point: 'Heat Exchanger Floating Damper Actuator Open Command',     ai: 0, ao: 0, di: 0, do: 1,     projectCode, description, location,     modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Heat Exchanger Floating Damper Actuator Close Command',   ai: 0, ao: 0, di: 0, do: 1,  projectCode, description, location,   modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Heat Exchanger Floating Damper Actuator Open Status',   ai: 0, ao: 0, di: 1, do: 0,  projectCode, description, location,   modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Heat Exchanger Floating Damper Actuator Close Status',  ai: 0, ao: 0, di: 1, do: 0,  projectCode, description, location,   modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (recuperatorDamperActuator === 'Proportional Damper Actuator') {recuperatorDamperRows.push({  point: 'Heat Exchanger Proportional Damper Actuator Command', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (recuperatorDamperActuator === 'Proportional Damper Actuator with Feedback') { recuperatorDamperRows.push( { point: 'Heat Exchanger Proportional Damper Actuator Command',  ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location,  modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Heat Exchanger Proportional Damper Actuator Feedback',  ai: 1, ao: 0, di: 0, do: 0,  projectCode, description, location,  modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (recuperatorDamperActuator === '2x On/Off Damper Actuator') {
  recuperatorDamperRows.push(
    {
      point: 'Heat Exchanger On/Off Damper Actuator Command-1',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Heat Exchanger On/Off Damper Actuator Command-2',
      ai: 0, ao: 0, di: 0, do: 1,
      projectCode, description, location,
      modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (recuperatorDamperActuator === '2x On/Off Damper Actuator with Feedback') {
  recuperatorDamperRows.push(
    {
      point: 'Heat Exchanger On/Off Damper Actuator Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    {
      point: 'Heat Exchanger On/Off Damper Actuator Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    {
      point: 'Heat Exchanger On/Off Damper Actuator Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    {
      point: 'Heat Exchanger On/Off Damper Actuator Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (recuperatorDamperActuator === '2x Floating Damper Actuator') {
  recuperatorDamperRows.push(
    {
      point: 'Heat Exchanger Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    {
      point: 'Heat Exchanger Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    {
      point: 'Heat Exchanger Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    {
      point: 'Heat Exchanger Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (recuperatorDamperActuator === '2x Floating Damper Actuator with Feedback') {
  recuperatorDamperRows.push(
    { point: 'Heat Exchanger Floating Damper Actuator Open Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heat Exchanger Floating Damper Actuator Close Command-1', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heat Exchanger Floating Damper Actuator Open Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heat Exchanger Floating Damper Actuator Close Status-1', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heat Exchanger Floating Damper Actuator Open Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heat Exchanger Floating Damper Actuator Close Command-2', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heat Exchanger Floating Damper Actuator Open Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heat Exchanger Floating Damper Actuator Close Status-2', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (recuperatorDamperActuator === '2x Proportional Damper Actuator') {
  recuperatorDamperRows.push(
    { point: 'Heat Exchanger Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heat Exchanger Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

if (recuperatorDamperActuator === '2x Proportional Damper Actuator with Feedback') {
  recuperatorDamperRows.push(
    { point: 'Heat Exchanger Proportional Damper Actuator Command-1', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heat Exchanger Proportional Damper Actuator Feedback-1', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heat Exchanger Proportional Damper Actuator Command-2', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'Heat Exchanger Proportional Damper Actuator Feedback-2', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}

const supplyFilterRows: any[] = [];

if (supplyFilter === 'Analog G4') {
  supplyFilterRows.push({
    point: 'Supply Filter G4 Pressure',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Digital G4') {
  supplyFilterRows.push({
    point: 'Supply Filter G4 Status',
    ai: 0, ao: 0, di: 1, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Analog F5') {
  supplyFilterRows.push({
    point: 'Supply Filter F5 Pressure',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Digital F5') {
  supplyFilterRows.push({
    point: 'Supply Filter F5 Status',
    ai: 0, ao: 0, di: 1, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Analog F6') {
  supplyFilterRows.push({
    point: 'Supply Filter F6 Pressure',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Digital F6') {
  supplyFilterRows.push({
    point: 'Supply Filter F6 Status',
    ai: 0, ao: 0, di: 1, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Analog F7') {
  supplyFilterRows.push({
    point: 'Supply Filter F7 Pressure',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Digital F7') {
  supplyFilterRows.push({
    point: 'Supply Filter F7 Status',
    ai: 0, ao: 0, di: 1, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Analog F8') {
  supplyFilterRows.push({
    point: 'Supply Filter F8 Pressure',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Digital F8') {
  supplyFilterRows.push({
    point: 'Supply Filter F8 Status',
    ai: 0, ao: 0, di: 1, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Analog F9') {
  supplyFilterRows.push({
    point: 'Supply Filter F9 Pressure',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Digital F9') {
  supplyFilterRows.push({
    point: 'Supply Filter F9 Status',
    ai: 0, ao: 0, di: 1, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Analog H13') {
  supplyFilterRows.push({
    point: 'Supply Filter H13 Pressure',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Digital H13') {
  supplyFilterRows.push({
    point: 'Supply Filter H13 Status',
    ai: 0, ao: 0, di: 1, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Analog H14') {
  supplyFilterRows.push({
    point: 'Supply Filter H14 Pressure',
    ai: 1, ao: 0, di: 0, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFilter === 'Digital H14') {
  supplyFilterRows.push({
    point: 'Supply Filter H14 Status',
    ai: 0, ao: 0, di: 1, do: 0,
    projectCode, description, location,
    modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

const freshFilterRows: any[] = [];

if (freshFilter === 'Analog G4') { freshFilterRows.push({   point: 'Fresh Filter G4 Pressure',   ai: 1, ao: 0, di: 0, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Digital G4') { freshFilterRows.push({   point: 'Fresh Filter G4 Status',   ai: 0, ao: 0, di: 1, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Analog F5') { freshFilterRows.push({   point: 'Fresh Filter F5 Pressure',   ai: 1, ao: 0, di: 0, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Digital F5') { freshFilterRows.push({   point: 'Fresh Filter F5 Status',   ai: 0, ao: 0, di: 1, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Analog F6') { freshFilterRows.push({   point: 'Fresh Filter F6 Pressure',   ai: 1, ao: 0, di: 0, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Digital F6') { freshFilterRows.push({   point: 'Fresh Filter F6 Status',   ai: 0, ao: 0, di: 1, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Analog F7') { freshFilterRows.push({   point: 'Fresh Filter F7 Pressure',   ai: 1, ao: 0, di: 0, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Digital F7') { freshFilterRows.push({   point: 'Fresh Filter F7 Status',   ai: 0, ao: 0, di: 1, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Analog F8') { freshFilterRows.push({   point: 'Fresh Filter F8 Pressure',   ai: 1, ao: 0, di: 0, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Digital F8') { freshFilterRows.push({   point: 'Fresh Filter F8 Status',   ai: 0, ao: 0, di: 1, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Analog F9') { freshFilterRows.push({   point: 'Fresh Filter F9 Pressure',   ai: 1, ao: 0, di: 0, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Digital F9') { freshFilterRows.push({   point: 'Fresh Filter F9 Status',   ai: 0, ao: 0, di: 1, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Analog H13') { freshFilterRows.push({   point: 'Fresh Filter H13 Pressure',   ai: 1, ao: 0, di: 0, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Digital H13') { freshFilterRows.push({   point: 'Fresh Filter H13 Status',   ai: 0, ao: 0, di: 1, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Analog H14') { freshFilterRows.push({   point: 'Fresh Filter H14 Pressure',   ai: 1, ao: 0, di: 0, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (freshFilter === 'Digital H14') { freshFilterRows.push({   point: 'Fresh Filter H14 Status',   ai: 0, ao: 0, di: 1, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

const returnFilterRows: any[] = [];

if (returnFilter === 'Analog G4') { returnFilterRows.push({   point: 'Return Filter G4 Pressure',   ai: 1, ao: 0, di: 0, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}
if (returnFilter === 'Digital G4') { returnFilterRows.push({   point: 'Return Filter G4 Status',   ai: 0, ao: 0, di: 1, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,  bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (returnFilter === 'Analog F5') { returnFilterRows.push({ point: 'Return Filter F5 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (returnFilter === 'Digital F5') { returnFilterRows.push({ point: 'Return Filter F5 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

if (returnFilter === 'Analog F6') { returnFilterRows.push({ point: 'Return Filter F6 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (returnFilter === 'Digital F6') { returnFilterRows.push({ point: 'Return Filter F6 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

if (returnFilter === 'Analog F7') { returnFilterRows.push({ point: 'Return Filter F7 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (returnFilter === 'Digital F7') { returnFilterRows.push({ point: 'Return Filter F7 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

if (returnFilter === 'Analog F8') { returnFilterRows.push({ point: 'Return Filter F8 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (returnFilter === 'Digital F8') { returnFilterRows.push({ point: 'Return Filter F8 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

if (returnFilter === 'Analog F9') { returnFilterRows.push({ point: 'Return Filter F9 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (returnFilter === 'Digital F9') { returnFilterRows.push({ point: 'Return Filter F9 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

if (returnFilter === 'Analog H13') { returnFilterRows.push({ point: 'Return Filter H13 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (returnFilter === 'Digital H13') {returnFilterRows.push({ point: 'Return Filter H13 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

if (returnFilter === 'Analog H14') { returnFilterRows.push({ point: 'Return Filter H14 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (returnFilter === 'Digital H14') { returnFilterRows.push({ point: 'Return Filter H14 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

const exhaustFilterRows: any[] = [];

if (exhaustFilter === 'Analog G4') { exhaustFilterRows.push({   point: 'Exhaust Filter G4 Pressure',   ai: 1, ao: 0, di: 0, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}
if (exhaustFilter === 'Digital G4') { exhaustFilterRows.push({   point: 'Exhaust Filter G4 Status',   ai: 0, ao: 0, di: 1, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (exhaustFilter === 'Analog F5') { exhaustFilterRows.push({   point: 'Exhaust Filter F5 Pressure',   ai: 1, ao: 0, di: 0, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}
if (exhaustFilter === 'Digital F5') { exhaustFilterRows.push({   point: 'Exhaust Filter F5 Status',   ai: 0, ao: 0, di: 1, do: 0,   projectCode, description, location,   modbusRtu: 0, modbusTcp: 0,   bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (exhaustFilter === 'Analog F6') {exhaustFilterRows.push({  point: 'Exhaust Filter F6 Pressure',  ai: 1, ao: 0, di: 0, do: 0,  projectCode, description, location,  modbusRtu: 0, modbusTcp: 0,  bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}
if (exhaustFilter === 'Digital F6') { exhaustFilterRows.push({  point: 'Exhaust Filter F6 Status',  ai: 0, ao: 0, di: 1, do: 0,  projectCode, description, location, modbusRtu: 0, modbusTcp: 0,  bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (exhaustFilter === 'Analog F7') { exhaustFilterRows.push({  point: 'Exhaust Filter F7 Pressure',  ai: 1, ao: 0, di: 0, do: 0,  projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}
if (exhaustFilter === 'Digital F7') {exhaustFilterRows.push({ point: 'Exhaust Filter F7 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location,  modbusRtu: 0, modbusTcp: 0,  bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (exhaustFilter === 'Analog F8') {exhaustFilterRows.push({ point: 'Exhaust Filter F8 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}
if (exhaustFilter === 'Digital F8') { exhaustFilterRows.push({ point: 'Exhaust Filter F8 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location,  modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (exhaustFilter === 'Analog F9') {exhaustFilterRows.push({ point: 'Exhaust Filter F9 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}
if (exhaustFilter === 'Digital F9') {exhaustFilterRows.push({ point: 'Exhaust Filter F9 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (exhaustFilter === 'Analog H13') {exhaustFilterRows.push({ point: 'Exhaust Filter H13 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}
if (exhaustFilter === 'Digital H13') { exhaustFilterRows.push({ point: 'Exhaust Filter H13 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location,  modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

if (exhaustFilter === 'Analog H14') { exhaustFilterRows.push({ point: 'Exhaust Filter H14 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (exhaustFilter === 'Digital H14') {exhaustFilterRows.push({ point: 'Exhaust Filter H14 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}



const recuperatorFilterRows: any[] = [];

if (recuperatorFilter === 'Analog G4') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter G4 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}
if (recuperatorFilter === 'Digital G4') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter G4 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (recuperatorFilter === 'Analog F5') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter F5 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (recuperatorFilter === 'Digital F5') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter F5 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

if (recuperatorFilter === 'Analog F6') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter F6 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (recuperatorFilter === 'Digital F6') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter F6 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

if (recuperatorFilter === 'Analog F7') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter F7 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (recuperatorFilter === 'Digital F7') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter F7 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

if (recuperatorFilter === 'Analog F8') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter F8 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (recuperatorFilter === 'Digital F8') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter F8 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

if (recuperatorFilter === 'Analog F9') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter F9 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (recuperatorFilter === 'Digital F9') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter F9 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

if (recuperatorFilter === 'Analog H13') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter H13 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (recuperatorFilter === 'Digital H13') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter H13 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}

if (recuperatorFilter === 'Analog H14') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter H14 Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}
if (recuperatorFilter === 'Digital H14') {recuperatorFilterRows.push({ point: 'Heat Exchanger Filter H14 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}



const supplyFlowRows: any[] = [];

if (supplyFlow === 'Belt') { supplyFlowRows.push({point: 'Supply Fan Belt Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFlow === 'Pressure') {supplyFlowRows.push({point: 'Supply Fan Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFlow === 'Volume') {supplyFlowRows.push({point: 'Supply Fan Volume', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (supplyFlow === 'Belt and Pressure') {supplyFlowRows.push({ point: 'Supply Fan Belt Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Supply Fan Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (supplyFlow === 'Belt and Volume') {supplyFlowRows.push({ point: 'Supply Fan Belt Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Supply Fan Volume', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (supplyFlow === 'Pressure and Volume') {supplyFlowRows.push({ point: 'Supply Fan Pressure',ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Supply Fan Volume', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (supplyFlow === 'Belt, Pressure and Volume') {supplyFlowRows.push({ point: 'Supply Fan Belt Status',  ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Supply Fan Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    {
      point: 'Supply Fan Volume', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 });
}


const returnFlowRows: any[] = [];

if (returnFlow === 'Belt') {returnFlowRows.push({ point: 'Return Fan Belt Status',  ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0,  bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (returnFlow === 'Pressure') {returnFlowRows.push({ point: 'Return Fan Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (returnFlow === 'Volume') {returnFlowRows.push({ point: 'Return Fan Volume', ai: 1, ao: 0, di: 0, do: 0,projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
  });
}

if (returnFlow === 'Belt and Pressure') {returnFlowRows.push( {  point: 'Return Fan Belt Status',  ai: 0, ao: 0, di: 1, do: 0,  projectCode, description, location,  modbusRtu: 0, modbusTcp: 0,  bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Return Fan Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location,  modbusRtu: 0, modbusTcp: 0,  bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (returnFlow === 'Belt and Volume') {returnFlowRows.push( {
      point: 'Return Fan Belt Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Return Fan Volume', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location,  modbusRtu: 0, modbusTcp: 0,  bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (returnFlow === 'Pressure and Volume') {returnFlowRows.push( { point: 'Return Fan Pressure', ai: 1, ao: 0, di: 0, do: 0,  projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Return Fan Volume', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

if (returnFlow === 'Belt, Pressure and Volume') {returnFlowRows.push( { point: 'Return Fan Belt Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Return Fan Pressure', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location,  modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    },
    {
      point: 'Return Fan Volume', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location,  modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0
    }
  );
}

const pumpPieces = Number(runAroundPumpPieces) || 1;
let runAroundPumpRows: any[] = [];

if (runAroundPumpControl === 'DOL' || runAroundPumpControl === 'Star-Delta') {
  const dolRows = [
    { point: 'Run Around Pump Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Command', ai: 0, ao: 0, di: 0, do: 1 }
  ];

  for (let i = 1; i <= pumpPieces; i++) {
    const suffix = pumpPieces > 1 ? ` ${i}` : '';
    dolRows.forEach(row => {
      runAroundPumpRows.push({
        projectCode,
        description,
        location,
        point: `${row.point}${suffix}`,
        ai: row.ai,
        ao: row.ao,
        di: row.di,
        do: row.do,
        modbusRtu: 0,
        modbusTcp: 0,
        bacnetMstp: 0,
        bacnetIp: 0,
        mbus: 0
      });
    });
  }
}

if (runAroundPumpControl === 'VFD') {
  const vfdRows = [
    { point: 'Run Around Pump Frequency Inverter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Frequency Inverter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Frequency Inverter Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Frequency Inverter Command', ai: 0, ao: 0, di: 0, do: 1 },
    { point: 'Run Around Pump Frequency Inverter Proportional Control', ai: 1, ao: 0, di: 0, do: 0 },
    { point: 'Run Around Pump Frequency Inverter Feedback', ai: 0, ao: 1, di: 0, do: 0 }
  ];

  for (let i = 1; i <= pumpPieces; i++) {
    const suffix = pumpPieces > 1 ? ` ${i}` : '';
    vfdRows.forEach(row => {
      runAroundPumpRows.push({
        projectCode,
        description,
        location,
        point: `${row.point}${suffix}`,
        ai: row.ai,
        ao: row.ao,
        di: row.di,
        do: row.do,
        modbusRtu: 0,
        modbusTcp: 0,
        bacnetMstp: 0,
        bacnetIp: 0,
        mbus: 0
      });
    });
  }
}




if (runAroundPumpControl === 'Power Supply Only ( Smart Pump)') {
  const vfdRows = [
    { point: 'Run Around Pump Frequency Inverter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Frequency Inverter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Frequency Inverter Command', ai: 0, ao: 0, di: 0, do: 1 },
    { point: 'Run Around Pump Frequency Inverter Proportional Control', ai: 1, ao: 0, di: 0, do: 0 },
    { point: 'Run Around Pump Frequency Inverter Feedback', ai: 0, ao: 1, di: 0, do: 0 }
  ];

  for (let i = 1; i <= pumpPieces; i++) {
    const suffix = pumpPieces > 1 ? ` ${i}` : '';
    vfdRows.forEach(row => {
      runAroundPumpRows.push({
        projectCode,
        description,
        location,
        point: `${row.point}${suffix}`,
        ai: row.ai,
        ao: row.ao,
        di: row.di,
        do: row.do,
        modbusRtu: 0,
        modbusTcp: 0,
        bacnetMstp: 0,
        bacnetIp: 0,
        mbus: 0
      });
    });
  }
}





if (runAroundPumpControl === 'VFD with By Pass Circuit' || runAroundPumpControl === 'VFD with By Pass Circuit + Star-Delta') {
  const vfdBypassRows = [
    { point: 'Run Around Pump Frequency Inverter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Contactor Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Frequency Inverter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Circuit Breaker Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Frequency Inverter Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump By/Pass Switch', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Frequency Inverter Command', ai: 0, ao: 0, di: 0, do: 1 },
    { point: 'Run Around Pump Frequency Inverter Proportional Control', ai: 0, ao: 1, di: 0, do: 0 },
    { point: 'Run Around Pump Frequency Inverter Feedback', ai: 1, ao: 0, di: 0, do: 0 }
  ];

  for (let i = 1; i <= pumpPieces; i++) {
    const suffix = pumpPieces > 1 ? ` ${i}` : '';
    vfdBypassRows.forEach(row => {
      runAroundPumpRows.push({
        projectCode,
        description,
        location,
        point: `${row.point}${suffix}`,
        ai: row.ai,
        ao: row.ao,
        di: row.di,
        do: row.do,
        modbusRtu: 0,
        modbusTcp: 0,
        bacnetMstp: 0,
        bacnetIp: 0,
        mbus: 0
      });
    });
  }
}

if (runAroundPumpControl === 'Soft Starter') {
  const softRows = [
    { point: 'Run Around Pump Soft Starter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Soft Starter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Soft Starter Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Soft Starter Command', ai: 0, ao: 0, di: 0, do: 1 }
  ];

  for (let i = 1; i <= pumpPieces; i++) {
    const suffix = pumpPieces > 1 ? ` ${i}` : '';
    softRows.forEach(row => {
      runAroundPumpRows.push({
        projectCode,
        description,
        location,
        point: `${row.point}${suffix}`,
        ai: row.ai,
        ao: row.ao,
        di: row.di,
        do: row.do,
        modbusRtu: 0,
        modbusTcp: 0,
        bacnetMstp: 0,
        bacnetIp: 0,
        mbus: 0
      });
    });
  }
}

if (runAroundPumpControl === 'Soft Starter with By Pass Circuit' || runAroundPumpControl === 'Soft Starter with By Pass Circuit + Star-Delta') {
  const softBypassRows = [
    { point: 'Run Around Pump Soft Starter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Contactor Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Soft Starter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Circuit Breaker Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Soft Starter Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump By Pass Switch Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Run Around Pump Soft Starter Command', ai: 0, ao: 0, di: 0, do: 1 }
  ];

  for (let i = 1; i <= pumpPieces; i++) {
    const suffix = pumpPieces > 1 ? ` ${i}` : '';
    softBypassRows.forEach(row => {
      runAroundPumpRows.push({
        projectCode,
        description,
        location,
        point: `${row.point}${suffix}`,
        ai: row.ai,
        ao: row.ao,
        di: row.di,
        do: row.do,
        modbusRtu: 0,
        modbusTcp: 0,
        bacnetMstp: 0,
        bacnetIp: 0,
        mbus: 0
      });
    });
  }
}

let runaroundCoilTemperatureRows: any[] = [];

if (runAroundTemperature === 'Inlet Temperature') {
  runaroundCoilTemperatureRows.push({
    projectCode,
    description,
    location,
    point: 'Run Around Coil Inlet Temperature',
    ai: 1,
    ao: 0,
    di: 0,
    do: 0,
    modbusRtu: 0,
    modbusTcp: 0,
    bacnetMstp: 0,
    bacnetIp: 0,
    mbus: 0
  });
}

if (runAroundTemperature === 'Outlet Temperature') {
  runaroundCoilTemperatureRows.push({
    projectCode,
    description,
    location,
    point: 'Run Around Coil Outlet Temperature',
    ai: 1,
    ao: 0,
    di: 0,
    do: 0,
    modbusRtu: 0,
    modbusTcp: 0,
    bacnetMstp: 0,
    bacnetIp: 0,
    mbus: 0
  });
}

if (runAroundTemperature === 'Inlet and Outlet Temperature') {
  runaroundCoilTemperatureRows.push(
    {
      projectCode,
      description,
      location,
      point: 'Run Around Coil Inlet Temperature',
      ai: 1,
      ao: 0,
      di: 0,
      do: 0,
      modbusRtu: 0,
      modbusTcp: 0,
      bacnetMstp: 0,
      bacnetIp: 0,
      mbus: 0
    },
    {
      projectCode,
      description,
      location,
      point: 'Run Around Coil Outlet Temperature',
      ai: 1,
      ao: 0,
      di: 0,
      do: 0,
      modbusRtu: 0,
      modbusTcp: 0,
      bacnetMstp: 0,
      bacnetIp: 0,
      mbus: 0
    }
  );
}

let heatExchangerRows: any[] = [];

if (heatRecoveryControl === 'Heat Wheel with MCC (DOL)') {
  const rows = [
    { point: 'Heat Exchanger Wheel Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Heat Exchanger Wheel Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Heat Exchanger Wheel Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Heat Exchanger Wheel Command', ai: 0, ao: 0, di: 0, do: 1 },
  ];
  heatExchangerRows = rows.map(row => ({
    projectCode,
    description,
    location,
    point: row.point,
    ai: row.ai,
    ao: row.ao,
    di: row.di,
    do: row.do,
    modbusRtu: 0,
    modbusTcp: 0,
    bacnetMstp: 0,
    bacnetIp: 0,
    mbus: 0
  }));
}

if (heatRecoveryControl === 'Heat Wheel with MCC (VFD)') {
  const rows = [
    { point: 'Heat Exchanger Wheel Frequency Inverter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Heat Exchanger Wheel Frequency Inverter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Heat Exchanger Wheel Frequency Inverter Auto/Manual', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Heat Exchanger Wheel Frequency Inverter Command', ai: 0, ao: 0, di: 0, do: 1 },
    { point: 'Heat Exchanger Wheel Frequency Inverter Proportional Control', ai: 0, ao: 1, di: 0, do: 0 },
    { point: 'Heat Exchanger Wheel Frequency Inverter Feedback', ai: 1, ao: 0, di: 0, do: 0 },
  ];
  heatExchangerRows = rows.map(row => ({
    projectCode,
    description,
    location,
    point: row.point,
    ai: row.ai,
    ao: row.ao,
    di: row.di,
    do: row.do,
    modbusRtu: 0,
    modbusTcp: 0,
    bacnetMstp: 0,
    bacnetIp: 0,
    mbus: 0
  }));
}

if (heatRecoveryControl === 'Heat Wheel with Packaged') {
  const rows = [
    { point: 'Heat Exchanger Wheel Frequency Inverter Status', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Heat Exchanger Wheel Frequency Inverter Fault', ai: 0, ao: 0, di: 1, do: 0 },
    { point: 'Heat Exchanger Wheel Frequency Inverter Command', ai: 0, ao: 0, di: 0, do: 1 },
    { point: 'Heat Exchanger Wheel Frequency Inverter Proportional Command', ai: 0, ao: 1, di: 0, do: 0 },
  ];
  heatExchangerRows = rows.map(row => ({
    projectCode,
    description,
    location,
    point: row.point,
    ai: row.ai,
    ao: row.ao,
    di: row.di,
    do: row.do,
    modbusRtu: 0,
    modbusTcp: 0,
    bacnetMstp: 0,
    bacnetIp: 0,
    mbus: 0
  }));
}

const humidificationRows: any[] = [];


if (humidificationFunction === 'Proportional Humidification') {
  humidificationRows.push(
    { point: 'On/Off Humidification Unit Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit Proportional Control', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit Feedback', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}


if (humidificationFunction === '1-Staged Humidification') {
  humidificationRows.push(
    { point: 'On/Off Humidification Unit Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    

  );
}

if (humidificationFunction === '2-Staged Humidification') {
  humidificationRows.push(
    { point: 'On/Off Humidification Unit-1 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit-1 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit-1 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit-2 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit-2 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit-2 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
  );
}

if (humidificationFunction === '3-Staged Humidification') {
  humidificationRows.push(
    { point: 'On/Off Humidification Unit-1 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit-1 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit-1 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit-2 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit-2 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit-2 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit-3 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit-3 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Humidification Unit-3 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
  );
}

const dehumidificationRows: any[] = [];


if (dehumidificationFunction === 'Proportional Dehumidification') {
  dehumidificationRows.push(
    { point: 'On/Off Dehumidification Unit Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit Proportional Control', ai: 0, ao: 1, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit Feedback', ai: 1, ao: 0, di: 0, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 }
  );
}


if (dehumidificationFunction === '1-Staged Dehumidification') {
  dehumidificationRows.push(
    { point: 'On/Off Dehumidification Unit Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    

  );
}

if (dehumidificationFunction === '2-Staged Dehumidification') {
  dehumidificationRows.push(
    { point: 'On/Off Dehumidification Unit-1 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit-1 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit-1 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit-2 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit-2 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit-2 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
  );
}

if (dehumidificationFunction === '3-Staged Dehumidification') {
  dehumidificationRows.push(
    { point: 'On/Off Dehumidification Unit-1 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit-1 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit-1 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit-2 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit-2 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit-2 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit-3 Status', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit-3 Fault', ai: 0, ao: 0, di: 1, do: 0, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
    { point: 'On/Off Dehumidification Unit-3 Command', ai: 0, ao: 0, di: 0, do: 1, projectCode, description, location, modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0, mbus: 0 },
  );
}

const fanIntegrationRows: any[] = [];

if (
  fanIntegration !== 'none' &&
  fanprotocolIntegration &&
  fanIntegrationPoints &&
  !isPackaged
) {
  const vantPiecesNum = Number(vantPieces) || 0;
  const aspPiecesNum = Number(aspPieces) || 0;
  const fanPointsNum = Number(fanIntegrationPoints) || 0;
  
  const totalPoints = (vantPiecesNum + aspPiecesNum) * fanPointsNum;

  const pointName = `Fan General ${fanIntegration} Integration Points`;

  const protocolValues = {
    'Modbus RTU': { modbusRtu: totalPoints, modbusTcp: 0, bacnetMstp: 0, bacnetIp: 0 },
    'Modbus TCP IP': { modbusRtu: 0, modbusTcp: totalPoints, bacnetMstp: 0, bacnetIp: 0 },
    'Bacnet MSTP': { modbusRtu: 0, modbusTcp: 0, bacnetMstp: totalPoints, bacnetIp: 0 },
    'Bacnet IP': { modbusRtu: 0, modbusTcp: 0, bacnetMstp: 0, bacnetIp: totalPoints },
  };

  const protocol = protocolValues[fanprotocolIntegration as keyof typeof protocolValues] || {
    modbusRtu: 0,
    modbusTcp: 0,
    bacnetMstp: 0,
    bacnetIp: 0
  };

  fanIntegrationRows.push({
    point: pointName,
    description,
    location,
    ai: 0,
    ao: 0,
    di: 0,
    do: 0,
    modbusRtu: protocol.modbusRtu,
    modbusTcp: protocol.modbusTcp,
    bacnetMstp: protocol.bacnetMstp,
    bacnetIp: protocol.bacnetIp,
    mbus: 0,
    projectCode
  });
}

const runaroundPumpIntegrationRows: any[] = [];

if (
  runaroundpumpIntegration !== 'none' &&
  runaroundpumpprotocolIntegration &&
  runaroundpumpIntegrationPoints &&
  !isPackaged
) {
  const pumpPiecesNum = Number(runAroundPumpPieces) || 0;
  const pumpPointsNum = Number(runaroundpumpIntegrationPoints) || 0;
  
  const totalPoints = pumpPiecesNum * pumpPointsNum;

  const pointName = `Runaround Pump General ${runaroundpumpIntegration} Integration Points`;

  const protocol = {
    modbusRtu: runaroundpumpprotocolIntegration === 'Modbus RTU' ? totalPoints : 0,
    modbusTcp: runaroundpumpprotocolIntegration === 'Modbus TCP IP' ? totalPoints : 0,
    bacnetMstp: runaroundpumpprotocolIntegration === 'Bacnet MSTP' ? totalPoints : 0,
    bacnetIp: runaroundpumpprotocolIntegration === 'Bacnet IP' ? totalPoints : 0
  };

  runaroundPumpIntegrationRows.push({
    point: pointName,
    description,
    location,
    ai: 0,
    ao: 0,
    di: 0,
    do: 0,
    modbusRtu: protocol.modbusRtu,
    modbusTcp: protocol.modbusTcp,
    bacnetMstp: protocol.bacnetMstp,
    bacnetIp: protocol.bacnetIp,
    mbus: 0,
    projectCode
  });
}
const heatExchangerIntegrationRows: any[] = [];

if (
  heatexchangerIntegration !== 'none' &&
  heatexchangerprotocolIntegration &&
  heatexchangerIntegrationPoints &&
  !isPackaged
) {
  const pointName = `Heat Exchanger ${heatexchangerIntegration} Integration Points`;

  const pointValue = parseInt(heatexchangerIntegrationPoints) || 0;

  const protocol = {
    modbusRtu: heatexchangerprotocolIntegration === 'Modbus RTU' ? pointValue : 0,
    modbusTcp: heatexchangerprotocolIntegration === 'Modbus TCP IP' ? pointValue : 0,
    bacnetMstp: heatexchangerprotocolIntegration === 'Bacnet MSTP' ? pointValue : 0,
    bacnetIp: heatexchangerprotocolIntegration === 'Bacnet IP' ? pointValue : 0
  };

  heatExchangerIntegrationRows.push({
    point: pointName,
    description,
    location,
    ai: 0,
    ao: 0,
    di: 0,
    do: 0,
    modbusRtu: protocol.modbusRtu,
    modbusTcp: protocol.modbusTcp,
    bacnetMstp: protocol.bacnetMstp,
    bacnetIp: protocol.bacnetIp,
    mbus: 0,
    projectCode
  });
}

const humidificationIntegrationRows: any[] = [];

if (
  humidificationIntegration !== 'none' &&
  humidificationprotocolIntegration &&
  humidificationIntegrationPoints &&
  !isPackaged
) {
  const pointName = `Humidification General ${humidificationIntegration} Integration Points`;

  const pointValue = parseInt(humidificationIntegrationPoints) || 0;

  const protocol = {
    modbusRtu: humidificationprotocolIntegration === 'Modbus RTU' ? pointValue : 0,
    modbusTcp: humidificationprotocolIntegration === 'Modbus TCP IP' ? pointValue : 0,
    bacnetMstp: humidificationprotocolIntegration === 'Bacnet MSTP' ? pointValue : 0,
    bacnetIp: humidificationprotocolIntegration === 'Bacnet IP' ? pointValue : 0
  };

  humidificationIntegrationRows.push({
    point: pointName,
    description,
    location,
    ai: 0,
    ao: 0,
    di: 0,
    do: 0,
    modbusRtu: protocol.modbusRtu,
    modbusTcp: protocol.modbusTcp,
    bacnetMstp: protocol.bacnetMstp,
    bacnetIp: protocol.bacnetIp,
    mbus: 0,
    projectCode
  });
}

const dehumidificationIntegrationRows: any[] = [];

if (
  dehumidificationIntegration !== 'none' &&
  dehumidificationprotocolIntegration &&
  dehumidificationIntegrationPoints &&
  !isPackaged
) {
  const pointName = `Dehumidification General ${dehumidificationIntegration} Integration Points`;

  const pointValue = parseInt(dehumidificationIntegrationPoints) || 0;

  const protocol = {
    modbusRtu: dehumidificationprotocolIntegration === 'Modbus RTU' ? pointValue : 0,
    modbusTcp: dehumidificationprotocolIntegration === 'Modbus TCP IP' ? pointValue : 0,
    bacnetMstp: dehumidificationprotocolIntegration === 'Bacnet MSTP' ? pointValue : 0,
    bacnetIp: dehumidificationprotocolIntegration === 'Bacnet IP' ? pointValue : 0
  };

  dehumidificationIntegrationRows.push({
    point: pointName,
    description,
    location,
    ai: 0,
    ao: 0,
    di: 0,
    do: 0,
    modbusRtu: protocol.modbusRtu,
    modbusTcp: protocol.modbusTcp,
    bacnetMstp: protocol.bacnetMstp,
    bacnetIp: protocol.bacnetIp,
    mbus: 0,
    projectCode
  });
}


setTableRows([]);

setTableRows([
  ...vantrows,
  ...asprows,
  ...maintenanceRows,
  ...emergencyRows,
  ...doorRows,
  ...fireRows,
  ...frostRows,
  ...preheatingRows,
  ...preheatingTemperatureRows,
  ...heatingRows,
  ...heatingTemperatureRows,
  ...coolingRows,
  ...coolingTemperatureRows,
  ...supplyAirSensorRows,
  ...freshAirSensorRows,
  ...returnAirSensorRows,
  ...exhaustAirSensorRows,
  ...mixedAirSensorRows,
  ...dehumidificationAirRows,
  ...heatExchangerAirRows,
  ...freshDamperRows,
  ...supplyDamperRows,
  ...returnDamperRows,
  ...exhaustDamperRows,
  ...mixedDamperRows,
  ...reCirculationDamperRows,
  ...recuperatorDamperRows,
  ...supplyFilterRows,
  ...freshFilterRows,
  ...returnFilterRows,
  ...exhaustFilterRows,
  ...recuperatorFilterRows,
  ...supplyFlowRows,
  ...returnFlowRows,
  ...runAroundPumpRows,
  ...runaroundCoilTemperatureRows,
  ...heatExchangerRows,
  ...humidificationRows,
  ...dehumidificationRows,
  ...fanIntegrationRows,
  ...runaroundPumpIntegrationRows,
  ...heatExchangerIntegrationRows,
  ...humidificationIntegrationRows,
  ...dehumidificationIntegrationRows,
  ...ahuControlPackagedRows
]);


setShowTable(true);
  };


  // Anahtar: tablodaki Project Code'a göre yaz (input'a güvenme)
const handleAddPool = () => {
  if (!tableRows || tableRows.length === 0) {
    setSnackbarMsg('No rows to add. Please generate the table first.');
    setSnackbarOpen(true);
    return;
  }

  const codes = Array.from(new Set(
    tableRows
      .map((r: any) => (r.projectCode ?? '').trim())
      .filter((c: string) => c.length > 0)
  ));

  if (codes.length === 0) {
    setSnackbarMsg('Rows have no Project Code. Please fill and try again.');
    setSnackbarOpen(true);
    return;
  }

  if (codes.length > 1) {
    setSnackbarMsg(`Multiple Project Codes in table: ${codes.join(', ')}. Please keep a single Project Code.`);
    setSnackbarOpen(true);
    return;
  }

  const code = codes[0]; // tek proje kodu
  const key = `pool:${code}`;
  const existing = JSON.parse(localStorage.getItem(key) || '[]');

  const payload = {
    id: Date.now(),
    system: 'ahu',         // <-- AHU için sistem adı
    rows: tableRows,
    createdAt: new Date().toISOString(),
    meta: { description, location }
  };

  localStorage.setItem(key, JSON.stringify([...existing, payload]));

  setSnackbarMsg(`Added ${tableRows.length} row(s) to Pool`);
  setSnackbarOpen(true);

  // temizle
  setTableRows([]);
  setShowTable(false);
};



  return (
    <Box sx={{ minHeight: '100vh', background: 'radial-gradient(circle at top right, #1A237E, #000000)', color: '#FFFFFF', display: 'flex', flexDirection: 'column' }}>
      {/* Navbar */}
      <Box sx={{ py: 2, px: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'white', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }}>
  
  {/* Sol taraftaki havalogic logosu */}
  <Typography variant="body1" sx={{ fontWeight: 'normal', fontSize: '1.1rem' }}>
  <Box component="span" sx={{ color: '#1976d2' }}>hava</Box>
  <Box component="span" sx={{ color: '#B0BEC5' }}>logic</Box>
</Typography>

  {/* Sağ taraftaki kullanıcı ve logout */}
  <Stack direction="row" spacing={2} alignItems="center">
    <Typography variant="body1" sx={{ mr: 2, fontWeight: 500, color: '#1976d2' }}>{loggedInUser || 'User'}</Typography>
    <PrimaryButton startIcon={<ExitToAppIcon sx={{ fontSize: '1rem' }} />} onClick={handleLogout} sx={{ minWidth: '100px' }}>Logout</PrimaryButton>
  </Stack>

</Box>

      {/* Main Layout */}
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        {/* Form */}
        <Container maxWidth="sm" sx={{ py: 6, px: 2, maxWidth: '600px', ml: 4, mr: 2 }}>
          <Box sx={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', borderRadius: '12px', p: 4, width: '400px', maxWidth: '100%', maxHeight: '85vh', overflowY: 'auto' }}>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>AHU System Input</Typography>
            <Stack spacing={2}>
              <TextField
  label="Project Code"
  value={projectCode}
  onChange={(e) => setProjectCode(e.target.value)}
  fullWidth
  variant="outlined"
  InputLabelProps={{
    sx: { color: '#90A4AE', '&.Mui-focused': { color: '#B0BEC5' } },
  }}
  sx={{
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: '#B0BEC5' },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#90A4AE' },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#CFD8DC' },
  }}
  InputProps={{
    sx: {
      backgroundColor: 'transparent',
      '& .MuiInputBase-input': { color: '#ECEFF1' }, // dropdown ile aynı metin rengi
      '&.Mui-disabled .MuiInputBase-input': {
        WebkitTextFillColor: '#888',
        color: '#888',
      },
    },
  }}
/>

<TextField
  label="Description"
  value={description}
  onChange={(e) => setDescription(e.target.value)}
  fullWidth
  variant="outlined"
  InputLabelProps={{
    sx: { color: '#90A4AE', '&.Mui-focused': { color: '#B0BEC5' } },
  }}
  sx={{
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: '#B0BEC5' },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#90A4AE' },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#CFD8DC' },
  }}
  InputProps={{
    sx: {
      backgroundColor: 'transparent',
      '& .MuiInputBase-input': { color: '#ECEFF1' },
      '&.Mui-disabled .MuiInputBase-input': {
        WebkitTextFillColor: '#888',
        color: '#888',
      },
    },
  }}
/>

<TextField
  label="Located"
  value={location}
  onChange={(e) => setLocation(e.target.value)}
  fullWidth
  variant="outlined"
  InputLabelProps={{
    sx: { color: '#90A4AE', '&.Mui-focused': { color: '#B0BEC5' } },
  }}
  sx={{
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: '#B0BEC5' },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#90A4AE' },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#CFD8DC' },
  }}
  InputProps={{
    sx: {
      backgroundColor: 'transparent',
      '& .MuiInputBase-input': { color: '#ECEFF1' },
      '&.Mui-disabled .MuiInputBase-input': {
        WebkitTextFillColor: '#888',
        color: '#888',
      },
    },
  }}
/>

              {renderDropdown('Control Type', ahuControl, handleAhuControlChange, ['MCC', 'Packaged'])}
              {renderDropdown('Control Protocol Integration', ahucontrolpackagedprotocolIntegration, (e) => setAhuControlPackagedProtocolIntegration(e.target.value), ['Modbus RTU', 'Modbus TCP IP', 'Bacnet MSTP', 'Bacnet IP'], ahuControl === 'MCC')}
              
             <TextField
  label="Control Packaged Integration Points"
  value={ahuControlPackagedPoints}
  onChange={(e) => setAhuControlPackagedPoints(e.target.value)}
  fullWidth
  variant="outlined"
  disabled={ahuControl === 'MCC'}
  InputLabelProps={{
    sx: {
      color: '#90A4AE',
      '&.Mui-focused': { color: '#B0BEC5' },
    },
  }}
  sx={{
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: ahuControl === 'MCC' ? '#555' : '#B0BEC5',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: ahuControl === 'MCC' ? '#555' : '#90A4AE',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: ahuControl === 'MCC' ? '#555' : '#CFD8DC',
    },
  }}
  InputProps={{
    sx: {
      backgroundColor: ahuControl === 'MCC' ? '#1e1e1e' : 'transparent',
      '& .MuiInputBase-input': { color: '#ECEFF1' },
      '&.Mui-disabled .MuiInputBase-input': {
        WebkitTextFillColor: '#888',
        color: '#888',
      },
    },
  }}
/>

              
              {renderDropdown('Control Packaged Hard Points', ahucontrolpackagedhardpoints, (e) => setAhuControlPackagedHardPoints(e.target.value), ['none', 'Statuses', 'Command', 'Statuses and Command'], ahuControl === 'MCC')}

              {renderDropdown('Vantilator Control', vantControl, (e) => setVantControl(e.target.value), ['DOL', 'EC', 'Power Supply Only', 'Soft Starter', 'Soft Starter with By Pass Circuit', 'Soft Starter with By Pass Circuit + Star-Delta', 'Star-Delta', 'VFD', 'VFD with By Pass Circuit', 'VFD with By Pass Circuit + Star-Delta'], isPackaged)}
              {renderDropdown('Vantilator Pieces', vantPieces, (e) => setVantPieces(e.target.value), ['1', '2', '3', '4', '5', '6', '7', '8'], isPackaged)}
              {renderDropdown('Vantilator Power', fanPower, (e) => setFanPower(e.target.value), ['0,55', '0,75', '1,1', '1,5', '2,2', '3', '4', '5,5', '7,5', '11', '15', '18,5', '22', '30', '37', '45', '55', '75', '90', '110', '132', '160'], isPackaged)}
              {renderDropdown('Vantilator Voltage', fanVoltage, (e) => setFanVoltage(e.target.value), ['230', '380'], isPackaged)}
              {renderDropdown('Aspirator Control', aspControl, handleAspControlChange, ['none', 'DOL', 'EC', 'Power Supply Only', 'Soft Starter', 'Soft Starter with By Pass Circuit', 'Soft Starter with By Pass Circuit + Star-Delta','Star-Delta', 'VFD', 'VFD with By Pass Circuit', 'VFD with By Pass Circuit + Star-Delta'], isPackaged)}
              {renderDropdown('Aspirator Pieces', aspPieces, (e) => setAspPieces(e.target.value), ['1', '2', '3', '4', '5', '6', '7', '8'], aspControl === 'none'|| isPackaged)}
              {renderDropdown('Aspirator Power', aspPower, (e) => setAspPower(e.target.value), ['0,55', '0,75', '1,1', '1,5', '2,2', '3', '4', '5,5', '7,5', '11', '15', '18,5', '22', '30', '37', '45', '55', '75', '90', '110', '132', '160'], aspControl === 'none'|| isPackaged)}
              {renderDropdown('Aspirator Voltage', aspVoltage, (e) => setAspVoltage(e.target.value), ['230', '380'], aspControl === 'none'|| isPackaged)}
              {renderDropdown('Maintenance Safety Contacts', maintenanceSafety, (e) => setMaintenanceSafety(e.target.value), ['none', 'for Each Fan', 'for All Fans'], isPackaged)}
              {renderDropdown('Emergency Safety Contacts', emergencySafety, (e) => setEmergencySafety(e.target.value), ['none', 'for Each Fan', 'for All Fans'], isPackaged)}
              {renderDropdown('Door Safety Contacts', doorSafety, (e) => setDoorSafety(e.target.value), ['none', 'for Each Fan', 'for All Fans'], isPackaged)}
              {renderDropdown('Fire Safety Contacts', fireSafety, (e) => setFireSafety(e.target.value), ['none', 'only Viewing', 'Viewing and Control'], isPackaged)}
              {renderDropdown('Frost Safety Contacts', frostSafety, (e) => setFrostSafety(e.target.value), ['none', 'Automatic Reset', 'Manual Reset'], isPackaged)}
              {renderDropdown('Preheating Function', preheatingFunction, handlePreheatingFunctionChange, ['none', 'On/Off Valve Actuator', 'On/Off Valve Actuator with Feedback', 'Floating Valve Actuator', 'Floating Valve Actuator with Feedback','Proportional Valve Actuator', 'Proportional Valve Actuator with Feedback', '1-Staged Electrical Heater', '2-Staged Electrical Heater', '3-Staged Electrical Heater', 'Proportional Electrical Heater'], isPackaged)}
              {renderDropdown('Preheating Power', preheatingPower, (e) => setPreheatingPower(e.target.value), ['0,55', '0,75', '1,1', '1,5', '2,2', '3', '4', '5,5', '7,5', '11', '15', '18,5', '22', '30', '37', '45', '55', '75', '90', '110', '132', '160'], preheatingFunction === 'none' || preheatingValveOptions.includes(preheatingFunction)|| isPackaged)}
              {renderDropdown('Preheating Voltage', preheatingVoltage, (e) => setPreheatingVoltage(e.target.value), ['230', '380'], preheatingFunction === 'none' || preheatingValveOptions.includes(preheatingFunction)|| isPackaged)}
              {renderDropdown('Preheating Coil Temperature', preheatingTemperature, (e) => setPreheatingTemperature(e.target.value), ['none', 'Inlet Temperature', 'Outlet Temperature', 'Inlet and Outlet Temperature'], isPreheatingTemperatureDisabled() || isPackaged)}
              {renderDropdown('Heating Function', heatingFunction, handleHeatingFunctionChange, ['none', 'On/Off Valve Actuator', 'On/Off Valve Actuator with Feedback', 'Floating Valve Actuator', 'Floating Valve Actuator with Feedback', 'Proportional Valve Actuator', 'Proportional Valve Actuator with Feedback', '1-Staged Electrical Heater', '2-Staged Electrical Heater', '3-Staged Electrical Heater', 'Proportional Electrical Heater'], isPackaged)}
              {renderDropdown('Heating Power', heatingPower, (e) => setHeatingPower(e.target.value), ['0,55', '0,75', '1,1', '1,5', '2,2', '3', '4', '5,5', '7,5', '11', '15', '18,5', '22', '30', '37', '45', '55', '75', '90', '110', '132', '160'], heatingFunction === 'none' || heatingValveOptions.includes(heatingFunction)|| isPackaged)}
              {renderDropdown('Heating Voltage', heatingVoltage, (e) => setHeatingVoltage(e.target.value), ['230', '380'], heatingFunction === 'none' || heatingValveOptions.includes(heatingFunction)|| isPackaged)}
              {renderDropdown('Heating Coil Temperature', heatingTemperature, (e) => setHeatingTemperature(e.target.value), ['none', 'Inlet Temperature', 'Outlet Temperature', 'Inlet and Outlet Temperature'], isHeatingTemperatureDisabled() || isPackaged)}
              {renderDropdown('Cooling Function', coolingFunction, (e) => setCoolingFunction(e.target.value), ['none', 'On/Off Valve Actuator', 'On/Off Valve Actuator with Feedback', 'Floating Valve Actuator', 'Floating Valve Actuator with Feedback', 'Proportional Valve Actuator', 'Proportional Valve Actuator with Feedback', '1-Staged DX Unit', '2-Staged DX Unit', '3-Staged DX Unit', 'Proportional DX Unit'], isPackaged)}
              {renderDropdown('Cooling Power', coolingPower, (e) => setCoolingPower(e.target.value), ['0,55', '0,75', '1,1', '1,5', '2,2', '3', '4', '5,5', '7,5', '11', '15','18,5', '22', '30', '37', '45', '55', '75', '90', '110', '132', '160'], coolingFunction === 'none' || coolingValveOptions.includes(coolingFunction)|| isPackaged)}
              {renderDropdown('Cooling Voltage', coolingVoltage, (e) => setCoolingVoltage(e.target.value), ['230', '380'], coolingFunction === 'none' || coolingValveOptions.includes(coolingFunction)|| isPackaged)}
              {renderDropdown('Cooling Coil Temperature', coolingTemperature, (e) => setCoolingTemperature(e.target.value), ['none', 'Inlet Temperature', 'Outlet Temperature', 'Inlet and Outlet Temperature'], coolingFunction === 'none' || coolingDXOptions.includes(coolingFunction) || isPackaged)}

              {renderDropdown('Supply Air Measurement', supplyAirSensor, (e) => setSupplyAirSensor(e.target.value), ['none', 'Temperature', 'Humidity', 'Temperature and Humidity'], isPackaged)}
              {renderDropdown('Fresh Air Measurement', freshAirSensor, (e) => setFreshAirSensor(e.target.value), ['none', 'Temperature', 'Humidity', 'Temperature and Humidity'], isPackaged)}
              {renderDropdown('Return Air Measurement', returnAirSensor, (e) => setReturnAirSensor(e.target.value), ['none', 'Temperature', 'Humidity', 'Temperature and Humidity', 'Co2', 'Temperature, Humidity and Co2'], isPackaged)}
              {renderDropdown('Exhaust Air Measurement', exhaustAirSensor, (e) => setExhaustAirSensor(e.target.value), ['none', 'Temperature', 'Humidity', 'Temperature and Humidity'], isPackaged)}
              {renderDropdown('Mixed Air Measurement', mixedAirSensor, (e) => setMixedAirSensor(e.target.value), ['none', 'Temperature', 'Humidity', 'Temperature and Humidity'], isPackaged)}
              {renderDropdown('Dehumidification Air Measurement', dehumidificationAirSensor, (e) => setDehumidificationAirSensor(e.target.value), ['none', 'Temperature', 'Humidity', 'Temperature and Humidity'], isPackaged)}
              {renderDropdown('Heat Exchanger Air Measurement', heatExchangerAirSensor, (e) => setHeatExchangerAirSensor(e.target.value), ['none', 'Fresh Side Temperature', 'Return Side Temperature', 'Fresh and Return Side Temperature'], isPackaged)}
              {renderDropdown('Fresh Damper Actuator', freshDamperActuator, (e) => setFreshDamperActuator(e.target.value), ['none','On/Off Damper Actuator','On/Off Damper Actuator with Feedback','Floating Damper Actuator','Floating Damper Actuator with Feedback','Proportional Damper Actuator','Proportional Damper Actuator with Feedback','2x On/Off Damper Actuator','2x On/Off Damper Actuator with Feedback','2x Floating Damper Actuator','2x Floating Damper Actuator with Feedback','2x Proportional Damper Actuator', '2x Proportional Damper Actuator with Feedback' ], isPackaged)}
              {renderDropdown('Supply Damper Actuator', supplyDamperActuator, (e) => setSupplyDamperActuator(e.target.value), ['none','On/Off Damper Actuator','On/Off Damper Actuator with Feedback','Floating Damper Actuator','Floating Damper Actuator with Feedback','Proportional Damper Actuator','Proportional Damper Actuator with Feedback','2x On/Off Damper Actuator','2x On/Off Damper Actuator with Feedback','2x Floating Damper Actuator','2x Floating Damper Actuator with Feedback','2x Proportional Damper Actuator','2x Proportional Damper Actuator with Feedback' ], isPackaged)}
              {renderDropdown('Return Damper Actuator', returnDamperActuator, (e) => setReturnDamperActuator(e.target.value), ['none','On/Off Damper Actuator','On/Off Damper Actuator with Feedback','Floating Damper Actuator','Floating Damper Actuator with Feedback','Proportional Damper Actuator','Proportional Damper Actuator with Feedback','2x On/Off Damper Actuator','2x On/Off Damper Actuator with Feedback','2x Floating Damper Actuator','2x Floating Damper Actuator with Feedback','2x Proportional Damper Actuator','2x Proportional Damper Actuator with Feedback' ], isPackaged)}
              {renderDropdown('Exhaust Damper Actuator',exhaustDamperActuator, (e) => setExhaustDamperActuator(e.target.value), ['none','On/Off Damper Actuator','On/Off Damper Actuator with Feedback','Floating Damper Actuator','Floating Damper Actuator with Feedback','Proportional Damper Actuator','Proportional Damper Actuator with Feedback','2x On/Off Damper Actuator','2x On/Off Damper Actuator with Feedback','2x Floating Damper Actuator','2x Floating Damper Actuator with Feedback','2x Proportional Damper Actuator','2x Proportional Damper Actuator with Feedback' ], isPackaged)}
              {renderDropdown('Mixed Damper Actuator', mixedDamperActuator, (e) => setMixedDamperActuator(e.target.value), ['none','On/Off Damper Actuator','On/Off Damper Actuator with Feedback','Floating Damper Actuator','Floating Damper Actuator with Feedback', 'Proportional Damper Actuator', 'Proportional Damper Actuator with Feedback', '2x On/Off Damper Actuator', '2x On/Off Damper Actuator with Feedback', '2x Floating Damper Actuator', '2x Floating Damper Actuator with Feedback', '2x Proportional Damper Actuator', '2x Proportional Damper Actuator with Feedback' ], isPackaged)}
              {renderDropdown('Re Circulation Damper Actuator', reCirculationDamperActuator, (e) => setReCirculationDamperActuator(e.target.value), ['none','On/Off Damper Actuator', 'On/Off Damper Actuator with Feedback','Floating Damper Actuator','Floating Damper Actuator with Feedback', 'Proportional Damper Actuator', 'Proportional Damper Actuator with Feedback', '2x On/Off Damper Actuator', '2x On/Off Damper Actuator with Feedback', '2x Floating Damper Actuator', '2x Floating Damper Actuator with Feedback', '2x Proportional Damper Actuator', '2x Proportional Damper Actuator with Feedback' ], isPackaged)}
              {renderDropdown('Heat Exchanger Damper Actuator', recuperatorDamperActuator, (e) => setRecuperatorDamperActuator(e.target.value), ['none', 'On/Off Damper Actuator', 'On/Off Damper Actuator with Feedback', 'Floating Damper Actuator', 'Floating Damper Actuator with Feedback', 'Proportional Damper Actuator', 'Proportional Damper Actuator with Feedback', '2x On/Off Damper Actuator', '2x On/Off Damper Actuator with Feedback', '2x Floating Damper Actuator', '2x Floating Damper Actuator with Feedback', '2x Proportional Damper Actuator', '2x Proportional Damper Actuator with Feedback' ], isPackaged)}
              {renderDropdown('Supply Filter', supplyFilter, (e) => setSupplyFilter(e.target.value), ['none', 'Analog G4', 'Digital G4', 'Analog F5', 'Digital F5', 'Analog F6', 'Digital F6', 'Analog F7', 'Digital F7', 'Analog F8', 'Digital F8', 'Analog F9', 'Digital F9', 'Analog H13', 'Digital H13', 'Analog H14', 'Digital H14'], isPackaged)}
              {renderDropdown('Fresh Filter', freshFilter, (e) => setFreshFilter(e.target.value), ['none','Analog G4', 'Digital G4', 'Analog F5', 'Digital F5', 'Analog F6', 'Digital F6', 'Analog F7', 'Digital F7', 'Analog F8', 'Digital F8', 'Analog F9', 'Digital F9', 'Analog H13', 'Digital H13', 'Analog H14', 'Digital H14' ], isPackaged)}
              {renderDropdown('Return Filter', returnFilter, (e) => setReturnFilter(e.target.value), ['none', 'Analog G4', 'Digital G4', 'Analog F5', 'Digital F5', 'Analog F6', 'Digital F6', 'Analog F7', 'Digital F7', 'Analog F8', 'Digital F8', 'Analog F9', 'Digital F9', 'Analog H13', 'Digital H13', 'Analog H14', 'Digital H14' ], isPackaged)}
              {renderDropdown('Exhaust Filter', exhaustFilter, (e) => setExhaustFilter(e.target.value), ['none','Analog G4', 'Digital G4', 'Analog F5', 'Digital F5', 'Analog F6', 'Digital F6', 'Analog F7', 'Digital F7', 'Analog F8', 'Digital F8', 'Analog F9', 'Digital F9', 'Analog H13', 'Digital H13', 'Analog H14', 'Digital H14' ], isPackaged)}
              {renderDropdown('Heat Exchanger Filter', recuperatorFilter, (e) => setRecuperatorFilter(e.target.value), [ 'none', 'Analog G4', 'Digital G4', 'Analog F5', 'Digital F5', 'Analog F6', 'Digital F6', 'Analog F7', 'Digital F7', 'Analog F8', 'Digital F8', 'Analog F9', 'Digital F9', 'Analog H13', 'Digital H13', 'Analog H14', 'Digital H14' ], isPackaged)}
              {renderDropdown('Supply Flow', supplyFlow, (e) => setSupplyFlow(e.target.value), [ 'none', 'Belt', 'Pressure', 'Volume', 'Belt and Pressure', 'Belt and Volume', 'Pressure and Volume', 'Belt, Pressure and Volume'], isPackaged)}
              {renderDropdown('Return Flow', returnFlow, (e) => setReturnFlow(e.target.value), [ 'none', 'Belt', 'Pressure', 'Volume', 'Belt and Pressure', 'Belt and Volume', 'Pressure and Volume', 'Belt, Pressure and Volume'], isPackaged)}
              {renderDropdown('Run Around Pump Control', runAroundPumpControl, (e) => setRunAroundPumpControl(e.target.value), [ 'none', 'DOL', 'Power Supply Only ( Smart Pump)', 'Soft Starter', 'Soft Starter with By Pass Circuit', 'Soft Starter with By Pass Circuit + Star-Delta', 'Star-Delta', 'VFD', 'VFD with By Pass Circuit', 'VFD with By Pass Circuit + Star-Delta' ], isPackaged)}
              {renderDropdown('Run Around Pump Pieces', runAroundPumpPieces, (e) => setRunAroundPumpPieces(e.target.value), ['1', '2', '3', '4', '5', '6', '7', '8'], runAroundPumpControl === 'none'|| isPackaged)}
              {renderDropdown('Run Around Pump Power', pumpPower, (e) => setPumpPower(e.target.value), ['0,55', '0,75', '1,1', '1,5', '2,2', '3', '4', '5,5', '7,5', '11', '15', '18,5', '22', '30', '37', '45', '55', '75', '90', '110', '132', '160'], runAroundPumpControl === 'none'|| isPackaged)}
              {renderDropdown('Run Around Pump Voltage', pumpVoltage, (e) => setPumpVoltage(e.target.value), ['230', '380'], runAroundPumpControl === 'none'|| isPackaged)}
              {renderDropdown('Run Around Coil Temperature', runAroundTemperature,  (e) => setRunAroundTemperature(e.target.value), ['none', 'Inlet Temperature', 'Outlet Temperature', 'Inlet and Outlet Temperature'], runAroundPumpControl === 'none'|| isPackaged)}
              {renderDropdown('Heat Exchanger Control', heatRecoveryControl, (e) => setHeatRecoveryControl(e.target.value), ['none', 'Heat Wheel with MCC (DOL)', 'Heat Wheel with MCC (VFD)','Heat Wheel with Packaged', 'Plate Recuperator'], isPackaged)}
              {renderDropdown('Heat Exchanger Control Unit Power',  heatRecoveryPower,  (e) => setHeatRecoveryPower(e.target.value), ['0,55', '0,75', '1,1', '1,5', '2,2', '3', '4', '5,5', '7,5', '11'], (heatRecoveryControl === 'none' || heatRecoveryControl === 'Plate Recuperator' || isPackaged))}
              {renderDropdown('Heat Exchanger Control Unit Voltage', heatRecoveryVoltage, (e) => setHeatRecoveryVoltage(e.target.value), ['230', '380'], (heatRecoveryControl === 'none' || heatRecoveryControl === 'Plate Recuperator' || isPackaged))}
              {renderDropdown('Humidification Function', humidificationFunction, (e) => setHumidificationFunction(e.target.value), ['none', 'Proportional Humidification', '1-Staged Humidification', '2-Staged Humidification', '3-Staged Humidification'], isPackaged)}
              {renderDropdown('Humidification Power', humidificationPower, (e) => setHumidificationPower(e.target.value), ['0,55', '0,75', '1,1', '1,5', '2,2', '3', '4', '5,5', '7,5', '11', '15', '18,5', '22', '30', '37', '45', '55', '75', '90', '110', '132', '160'], humidificationFunction === 'none'|| isPackaged)}
              {renderDropdown('Humidification Voltage', humidificationVoltage, (e) => setHumidificationVoltage(e.target.value), ['230', '380'], humidificationFunction === 'none'|| isPackaged)}
              {renderDropdown('Dehumidification Function', dehumidificationFunction, (e) => setDehumidificationFunction(e.target.value), ['none', 'Proportional Dehumidification', '1-Staged Dehumidification', '2-Staged Dehumidification', '3-Staged Dehumidification'], isPackaged)}
              {renderDropdown('Dehumidification Control Unit Power', dehumidificationPower, (e) => setDehumidificationPower(e.target.value), ['0,55', '0,75', '1,1', '1,5', '2,2', '3', '4', '5,5', '7,5', '11', '15', '18,5', '22', '30', '37', '45', '55', '75', '90', '110', '132', '160'], dehumidificationFunction === 'none'|| isPackaged)}
              {renderDropdown('Dehumidification Control Unit Voltage', dehumidificationVoltage, (e) => setDehumidificationVoltage(e.target.value), ['230', '380'], dehumidificationFunction === 'none'|| isPackaged)}
              
              {renderDropdown('Fan Integration', fanIntegration, (e) => setFanIntegration(e.target.value), ['none', 'EC', 'VFD'], isPackaged)}
              {renderDropdown('Fan Protocol Integration', fanprotocolIntegration, (e) => setFanProtocolIntegration(e.target.value), ['Modbus RTU', 'Modbus TCP IP', 'Bacnet MSTP', 'Bacnet IP'], fanIntegration === 'none'|| isPackaged)}

            
              <TextField
  label="Fan Integration Points"
  value={fanIntegrationPoints}
  onChange={(e) => setFanIntegrationPoints(e.target.value)}
  fullWidth
  variant="outlined"
  disabled={fanIntegration === 'none' || isPackaged}
  InputLabelProps={{
    sx: {
      color: '#90A4AE',
      '&.Mui-focused': { color: '#B0BEC5' },
      '&.Mui-disabled': { color: '#888' },
    },
  }}
  sx={{
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: (fanIntegration === 'none' || isPackaged) ? '#555' : '#B0BEC5',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: (fanIntegration === 'none' || isPackaged) ? '#555' : '#90A4AE',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: (fanIntegration === 'none' || isPackaged) ? '#555' : '#CFD8DC',
    },
  }}
  InputProps={{
    sx: {
      backgroundColor: (fanIntegration === 'none' || isPackaged) ? '#1e1e1e' : 'transparent',
      '& .MuiInputBase-input': { color: '#ECEFF1' },
      '&.Mui-disabled .MuiInputBase-input': {
        WebkitTextFillColor: '#888',
        color: '#888',
      },
    },
  }}
/>



              {renderDropdown('Run Around Pump Integration', runaroundpumpIntegration, (e) => setRunAroundPumpIntegration(e.target.value), ['none', 'own Panel', 'VFD'], isPackaged)}
              {renderDropdown('Run Around Pump Protocol Integration', runaroundpumpprotocolIntegration, (e) => setRunAroundPumpProtocolIntegration(e.target.value), ['Modbus RTU', 'Modbus TCP IP', 'Bacnet MSTP', 'Bacnet IP'], runaroundpumpIntegration === 'none'|| isPackaged)}


              <TextField
  label="Run Around Pump Integration Points"
  value={runaroundpumpIntegrationPoints}
  onChange={(e) => setRunAroundPumpIntegrationPoints(e.target.value)}
  fullWidth
  variant="outlined"
  disabled={runaroundpumpIntegration === 'none' || isPackaged}
  InputLabelProps={{
    sx: {
      color: '#90A4AE',
      '&.Mui-focused': { color: '#B0BEC5' },
      '&.Mui-disabled': { color: '#888' },
    },
  }}
  sx={{
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: (runaroundpumpIntegration === 'none' || isPackaged) ? '#555' : '#B0BEC5',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: (runaroundpumpIntegration === 'none' || isPackaged) ? '#555' : '#90A4AE',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: (runaroundpumpIntegration === 'none' || isPackaged) ? '#555' : '#CFD8DC',
    },
  }}
  InputProps={{
    sx: {
      backgroundColor: (runaroundpumpIntegration === 'none' || isPackaged) ? '#1e1e1e' : 'transparent',
      '& .MuiInputBase-input': { color: '#ECEFF1' },
      '&.Mui-disabled .MuiInputBase-input': {
        WebkitTextFillColor: '#888',
        color: '#888',
      },
    },
  }}
/>




              {renderDropdown('Heat Exchanger Integration', heatexchangerIntegration, (e) => setHeatExchangerIntegration(e.target.value), ['none', 'own Panel'], isPackaged)}
              {renderDropdown('Heat Exchanger Protocol Integration', heatexchangerprotocolIntegration, (e) => setHeatExchangerProtocolIntegration(e.target.value), ['Modbus RTU', 'Modbus TCP IP', 'Bacnet MSTP', 'Bacnet IP'], heatexchangerIntegration === 'none'|| isPackaged)}


              <TextField
  label="Heat Exchanger Integration Points"
  value={heatexchangerIntegrationPoints}
  onChange={(e) => setHeatExchangerIntegrationPoints(e.target.value)}
  fullWidth
  variant="outlined"
  disabled={heatexchangerIntegration === 'none' || isPackaged}
  InputLabelProps={{
    sx: {
      color: '#90A4AE',
      '&.Mui-focused': { color: '#B0BEC5' },
      '&.Mui-disabled': { color: '#888' },
    },
  }}
  sx={{
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: (heatexchangerIntegration === 'none' || isPackaged) ? '#555' : '#B0BEC5',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: (heatexchangerIntegration === 'none' || isPackaged) ? '#555' : '#90A4AE',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: (heatexchangerIntegration === 'none' || isPackaged) ? '#555' : '#CFD8DC',
    },
  }}
  InputProps={{
    sx: {
      backgroundColor: (heatexchangerIntegration === 'none' || isPackaged) ? '#1e1e1e' : 'transparent',
      '& .MuiInputBase-input': { color: '#ECEFF1' },
      '&.Mui-disabled .MuiInputBase-input': {
        WebkitTextFillColor: '#888',
        color: '#888',
      },
    },
  }}
/>




              {renderDropdown('Humidification Integration', humidificationIntegration, (e) => setHumidificationIntegration(e.target.value), ['none', 'own Panel'], isPackaged)}
              {renderDropdown('Humidification Protocol Integration', humidificationprotocolIntegration, (e) => setHumidificationProtocolIntegration(e.target.value), ['Modbus RTU', 'Modbus TCP IP', 'Bacnet MSTP', 'Bacnet IP'], humidificationIntegration === 'none'|| isPackaged)}


              <TextField
  label="Humidification Integration Points"
  value={humidificationIntegrationPoints}
  onChange={(e) => setHumidificationIntegrationPoints(e.target.value)}
  fullWidth
  variant="outlined"
  disabled={humidificationIntegration === 'none' || isPackaged}
  InputLabelProps={{
    sx: {
      color: '#90A4AE',
      '&.Mui-focused': { color: '#B0BEC5' },
      '&.Mui-disabled': { color: '#888' },
    },
  }}
  sx={{
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: (humidificationIntegration === 'none' || isPackaged) ? '#555' : '#B0BEC5',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: (humidificationIntegration === 'none' || isPackaged) ? '#555' : '#90A4AE',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: (humidificationIntegration === 'none' || isPackaged) ? '#555' : '#CFD8DC',
    },
  }}
  InputProps={{
    sx: {
      backgroundColor: (humidificationIntegration === 'none' || isPackaged) ? '#1e1e1e' : 'transparent',
      '& .MuiInputBase-input': { color: '#ECEFF1' },
      '&.Mui-disabled .MuiInputBase-input': {
        WebkitTextFillColor: '#888',
        color: '#888',
      },
    },
  }}
/>





              {renderDropdown('Dehumidification Integration', dehumidificationIntegration, (e) => setDehumidificationIntegration(e.target.value), ['none', 'own Panel'], isPackaged)}
              {renderDropdown('Dehumidification Protocol Integration', dehumidificationprotocolIntegration, (e) => setDehumidificationProtocolIntegration(e.target.value), ['Modbus RTU', 'Modbus TCP IP', 'Bacnet MSTP', 'Bacnet IP'], dehumidificationIntegration === 'none'|| isPackaged)}


              <TextField
  label="Dehumidification Integration Points"
  value={dehumidificationIntegrationPoints}
  onChange={(e) => setDehumidificationIntegrationPoints(e.target.value)}
  fullWidth
  variant="outlined"
  disabled={dehumidificationIntegration === 'none' || isPackaged}
  InputLabelProps={{
    sx: {
      color: '#90A4AE',
      '&.Mui-focused': { color: '#B0BEC5' },
      '&.Mui-disabled': { color: '#888' },
    },
  }}
  sx={{
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: (dehumidificationIntegration === 'none' || isPackaged) ? '#555' : '#B0BEC5',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: (dehumidificationIntegration === 'none' || isPackaged) ? '#555' : '#90A4AE',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: (dehumidificationIntegration === 'none' || isPackaged) ? '#555' : '#CFD8DC',
    },
  }}
  InputProps={{
    sx: {
      backgroundColor: (dehumidificationIntegration === 'none' || isPackaged) ? '#1e1e1e' : 'transparent',
      '& .MuiInputBase-input': { color: '#ECEFF1' },
      '&.Mui-disabled .MuiInputBase-input': {
        WebkitTextFillColor: '#888',
        color: '#888',
      },
    },
  }}
/>



<PrimaryButton sx={{ width: '100%' }} onClick={handleSaveAhu}>Send to Table</PrimaryButton>

<PrimaryButton
  sx={{ width: '100%' }}
  onClick={handleAddPool}
  disabled={tableRows.length === 0}
>
  Add Pool
</PrimaryButton>



<PrimaryButton sx={{ width: '100%' }} onClick={handleBack}>Back to Project Overview</PrimaryButton>
</Stack>
</Box>
</Container>

{/* Tablo */}
<Box
  sx={{
    flex: 1,
    p: 4,
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    borderRadius: '12px',
    mr: 1,
    ml: 0,
    mt: 6,
    maxHeight: '85vh',
    overflowY: 'auto',
    
    color: 'white'
  }}
>
  <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
    {projectCode ? `${projectCode} Output Table` : 'AHU Output Table'}
  </Typography>




  <Box
    sx={{
      overflowX: 'auto',
      overflowY: 'auto',
      maxWidth: '100%',
    }}
  ></Box>


  {showTable && tableRows.length > 0 && (
      <table
        style={{
          minWidth: '1200px',
          borderCollapse: 'collapse',
          backgroundColor: '#ffffff',
          fontSize: '0.875rem',
          fontFamily: "'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif",
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
          border: '1px solid #e0e0e0',
          color: '#333',
        }}
      >
      <thead>
        <tr style={{ backgroundColor: '#1976d2', color: 'white' }}>
          {['Project Code', 'Description', 'Located', 'Point Name', 'AI', 'AO', 'DI', 'DO', 'Modbus RTU', 'Modbus TCP IP', 'Bacnet MSTP', 'Bacnet IP', 'Mbus'].map((header, i) => (
            <th
              key={i}
              style={{
                border: '1px solid #e0e0e0',
                padding: '10px',
                fontWeight: 500,
                fontSize: '0.85rem',
                textAlign: 'left'
              }}
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {tableRows.map((row, index) => (
          <tr
            key={index}
            style={{
              backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#f0f4f8',
              transition: 'background 0.3s',
              cursor: 'default'
            }}
          >
            <td
              style={{
                border: '1px solid #e0e0e0',
                padding: '8px',
                fontSize: '0.82rem',
                color: '#424242'
              }}
            >
              {row.projectCode}
            </td>

            <td
              style={{
                border: '1px solid #e0e0e0',
                padding: '8px',
                fontSize: '0.82rem',
                color: '#424242'
              }}
            >
              {row.description}
            </td>

            <td
              style={{
                border: '1px solid #e0e0e0',
                padding: '8px',
                fontSize: '0.82rem',
                color: '#424242'
              }}
            >
              {row.location}
            </td>

            <td
              style={{
                border: '1px solid #e0e0e0',
                padding: '8px',
                fontSize: '0.82rem',
                color: '#424242'
              }}
            >
              {row.point}
            </td>

            <td
              style={{
                border: '1px solid #e0e0e0',
                padding: '8px',
                fontSize: '0.82rem',
                color: '#424242'
              }}
            >
              {row.ai}
            </td>

            <td
              style={{
                border: '1px solid #e0e0e0',
                padding: '8px',
                fontSize: '0.82rem',
                color: '#424242'
              }}
            >
              {row.ao}
            </td>

            <td
              style={{
                border: '1px solid #e0e0e0',
                padding: '8px',
                fontSize: '0.82rem',
                color: '#424242'
              }}
            >
              {row.di}
            </td>

            <td
              style={{
                border: '1px solid #e0e0e0',
                padding: '8px',
                fontSize: '0.82rem',
                color: '#424242'
              }}
            >
              {row.do}
            </td>

            <td
              style={{
                border: '1px solid #e0e0e0',
                padding: '8px',
                fontSize: '0.82rem',
                color: '#424242'
              }}
            >
              {row.modbusRtu}
            </td>

            <td
              style={{
                border: '1px solid #e0e0e0',
                padding: '8px',
                fontSize: '0.82rem',
                color: '#424242'
              }}
            >
              {row.modbusTcp}
            </td>

            <td
              style={{
                border: '1px solid #e0e0e0',
                padding: '8px',
                fontSize: '0.82rem',
                color: '#424242'
              }}
            >
              {row.bacnetMstp}
            </td>

            <td
              style={{
                border: '1px solid #e0e0e0',
                padding: '8px',
                fontSize: '0.82rem',
                color: '#424242'
              }}
            >
              {row.bacnetIp}
            </td>

            <td
              style={{
                border: '1px solid #e0e0e0',
                padding: '8px',
                fontSize: '0.82rem',
                color: '#424242'
              }}
            >
              {row.mbus}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )}
</Box>
      </Box>

<Snackbar
  open={snackbarOpen}
  autoHideDuration={2000}
  onClose={() => setSnackbarOpen(false)}
  message={snackbarMsg}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
  sx={{
    '& .MuiSnackbarContent-root': {
      backgroundColor: '#4CAF50',
      color: '#fff',
      fontWeight: 500,
      padding: '10px 24px',
      minWidth: 'auto',
      justifyContent: 'center',
      textAlign: 'center',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    }
  }}
/>

    </Box>
  );
}